if ($("body").hasClass("logged")) {
  loggedin = "logged_in";
} else {
  loggedin = "guest";
}
// user id
if ($("body").hasClass("logged")) {
  var user_id_string = __st.cid;
  if(user_id_string){
    var user_id = user_id_string.toString();
  }
} else {
  var user_id = "NA";
}

/* Handle Zoom Image on Back Button */
$(document).ready(function () {
  // console.log('custom theme');
  const zoomCLoseButton = $(".pswp__button--close");

  /* Remove # from url */
  const removeHash = () => {
    if (window.location.href.split("").at(-1) == "#") {
      /* Just replace state so that it doesn't reload the page. */
      window.history.replaceState({},document.title,window.location.href.split("#")[0]);
    }
  };

  /* Removes # if reload the page */
  if ($(".Product__Slideshow")) {
    removeHash();
  }

  /* Handle close button of ZoomImage */
  if (zoomCLoseButton) {
    zoomCLoseButton.click(function (e) {
      e.preventDefault();
      if (window.innerWidth < 786) {
        removeHash();
      }
      //window.history.go(-1);
    });
  }

  /* If clicked on slider then append # in url to show that modal is opened  */
  const sliderContainer = $(".pswp");
  if (sliderContainer.length > 0) {
    // $(".Product__Slideshow").click(function () {
    //   window.location.href += "#";
    // });
  }

  /* On pressing back, we remove the ZoomImage class to disable it */
  window.addEventListener("hashchange",function () {
    // if (window.location.href.split("").at(-1) != "#") {
    //   document.querySelector(".pswp__ui")?.classList.add("pswp__ui--hidden");
    //   $(".pswp").attr("class", "pswp");
    // }
    CloseHamburger();
    if (window.innerWidth < 786) {
      if ($("#signin_popup") && $("#signin_popup").hasClass("showpopup"))
      $("#signin_popup").removeClass("showpopup");
    }
  },false);
});

/* Sort And Filter Back Button Handle */
$(document).ready(function (){
  const hamburgerMenu = document.querySelector(".header-side-menu");
  if (hamburgerMenu) {
    hamburgerMenu.addEventListener("click", () => {
      CustomOpenModalEvent();
      OpenHambuger();
    });
  }
});

/* get date and time */
var now = new Date();
var year = now.getFullYear();
var month = (now.getMonth() + 1).toString().padStart(2, "0");
var day = now.getDate().toString().padStart(2, "0");
var formattedDate = year + "-" + month + "-" + day;
// console.log(formattedDate);
var hours = now.getHours().toString().padStart(2, "0");
var minutes = now.getMinutes().toString().padStart(2, "0");
var seconds = now.getSeconds().toString().padStart(2, "0");
var formattedTime = hours + ":" + minutes + ":" + seconds;
// console.log(formattedTime);

var formatted = formattedDate + "T" + formattedTime;
// console.log("formatted", formatted);

// var data = [];
var pinValues;
var customerPrefix;

var value_input = $("#bh-sl-address").val();
if (Shopify.shop.indexOf("india") > -1) {
  customerPrefix = "IN"; // US for USA store, AE for Dubai store, IN for India store
} else if (Shopify.shop.indexOf("dubai") > -1) {
  customerPrefix = "AE"; // US for USA store, AE for Dubai store, IN for India store
} else if (Shopify.shop.indexOf("usa") > -1) {
  customerPrefix = "US"; // US for USA store, AE for Dubai store, IN for India store
} else {
  customerPrefix = "US"; // US for USA store, AE for Dubai store, IN for India store
}
// var customerId = $("body").attr("data-customer");
// var fitsmartCustomerId = customerPrefix + "-" + customerId;

var latitude;
var longitude;
var service;
var currentPosition;
var pinval;

var currentUrl = "https://www.bombayshirts.com/pages/stores";
var newUrl;

var urlParams = new URLSearchParams(window.location.search);
pinval = urlParams.get("pinval");

$("#bh-sl-address").val(pinval);
if(pinval != "" && pinval != undefined){
  $(".page-store .search-store .search_close_icon").removeClass("hide");
}

$(document).ready(function () {
  if (pinval) {
    // console.log("add Class");
    var geocoder = new google.maps.Geocoder();
    // console.log("geocoder", geocoder);

    geocoder.geocode({address: pinval,},function (results) {
      var place = {
        location: {
          lat: latitude,
          lng: longitude,
        },
        radius: "50000",
        type: ["clothing_store" | "store"],
        keyword: "Bombay Shirt Company",
      };
      console.log("results", results);
      if(results != null){
      var latitude = results[0].geometry.location.lat();
      var longitude = results[0].geometry.location.lng();
      var place = {};
      //use result[0] instead of place should work
      dispaly_stores(place, latitude, longitude);
      // service = new google.maps.places.PlacesService(
      //   document.createElement("div")
      // );
      }else{
        $(".store_loader").removeClass("store-loader-overlay");
        $("body").removeClass("store-loader");
      }
    });
  }
});

// var count_all_stores = $(".Grid__Cell.store-list-item").length;
// $(".store_count_text").text(count_all_stores);

// var count_popu_store = $(".Grid__Cell_popup.store-list-item").length;
// $(".store_count_text_popup").text(count_popu_store);

function initAutocomplete() {
  if(document.body.classList.contains("temp_store")){
    // console.log("initAutocomplete>>>>>>>");
    const map = new google.maps.Map(document.createElement("div"));
    const input = document.getElementById("bh-sl-address");
    const searchBox = new google.maps.places.SearchBox(input);
    // console.log("searchBox", searchBox);
  
    function placesChangedListener() {
      console.log("placesChangedListener");
      const target = document.querySelector('.store-list-popup');
      if (target) {
        const targetTop = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      }
      $(`[data-store-area-item]`).removeClass("active");
      $(`[data-store-area="all_stores"]`).addClass("active");
      document.body.classList.remove("city-dr-open");
      const places = searchBox.getPlaces();
      console.log("Places", places);
      if (places.length == 0) {
        noStoreFound_forPincodeBlock();
        return;
      }
  
      places.forEach((place) => {
        // console.log("place", place);
        if (place) {
          $(".search_close_icon").removeClass("hide");
          $(".current_location").removeClass("current-selected");
        }
  
        dispaly_stores(place);
        const addressComponents = place.address_components;
        // console.log("addressComponents",addressComponents)
      });
    }
    searchBox.addListener("places_changed", placesChangedListener);
  }
}

function dispaly_stores(place, userLatitude = "", userLongitude = "") {
  console.log("dispaly_stores",place);
  var current_pincode;
  var country;
  var state;
  var city;

  if (userLatitude == "") {
    var userLatitude = place.geometry.location.lat();
    var userLongitude = place.geometry.location.lng();
  }
  
  var maxDistance = 50;
  const nearbyStores = findNearbyStores(userLatitude,userLongitude,maxDistance);
  

  console.log("nearbyStores>>>>>>>",nearbyStores);

  // let storeCount = $(`.store-list .Grid__Cell[data-store-area="${$(this).attr("data-store-area")}"]`).length;
  if(place.name != null){
    $(`.filter-count-text`).html(`${nearbyStores.length} store${nearbyStores.length != 1 ? "s": ""} found`);
  }else{
    if(nearbyStores.length > 0){
      $(`.filter-count-text`).html(`${nearbyStores.length} store${nearbyStores.length != 1 ? "s" : ""} found`);
      // $(`[data-store-area-item][data-store-area="all_stores"]`).removeClass("active");
    }else{
      $(`.filter-count-text`).html(`Store Details`);
    }
  }
  
  if (nearbyStores.length > 0) {
    $(`[data-store-area-item][data-store-area="all_stores"]`).removeClass("active");
    $(".store-details").find(".store-list .Grid__Cell").addClass("hide");
    $(".store-details").removeClass("hide");
    $(".serch-btn").removeClass("changing");
    $(".btn_name").addClass("hide");
    $(".search_close_icon").removeClass("hide");
    localStorage.customerNearestStore = `Nearest store: ${document.querySelector(`.store-details .Grid__Cell[data-place-id="${nearbyStores[0].place_id}"]`).dataset.storeTitle}`;
  }else {
    setTimeout(function () {
      var value_input = $("#bh-sl-address").val();
      if (!isNaN(value_input)) {
        localStorage.customerPincode = value_input;
        manageHomeVisitForCD(value_input);
        $(".pinvlaue").text(value_input);
        $(".pincode_text").addClass("hide");
        $(".pincode_number").removeClass("hide");
      } else if (current_pincode) {
        var value_input = current_pincode;
        localStorage.customerPincode = value_input;
        manageHomeVisitForCD(value_input);
        $(".pinvlaue").text(value_input);
        $(".pincode_text").addClass("hide");
        $(".pincode_number").removeClass("hide");
      }
    }, 500);
    $(".all-stores .filter").addClass("hide");
    $(".why-visit").addClass("hide");
    $(".store-details").addClass("hide");
    $(".store-details").find(".store-list .Grid__Cell").removeClass("found_store");
    $(".store-not_found").removeClass("hide");
    $(".shopify-section .find-store .store-found-text").addClass("hide");
    $(".shopify-section .find-store .store-notfound-text").removeClass("hide");
    $(".store-not_found").find("p").text("No Nearby Stores Found");
    $(".store_loader").removeClass("store-loader-overlay");
    $("body").removeClass("store-loader");
    $(".store-details").find(".store-list .Grid__Cell").addClass("hide");
    localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
  }

  let lastIndex = false;
  // console.log("nearbyStores",nearbyStores);
  nearbyStores.forEach((place, index) => {
    
    if(index == (nearbyStores.length - 1)){
      lastIndex = true;
    }
    var getPlaceID = place.place_id;
    var store_length = nearbyStores.length;

    $(".find-store-innder .found-text").removeClass("changing");
    $(".store-details").removeClass("hide");
    $(".store_loader").removeClass("store-loader-overlay");
    $("body").removeClass("store-loader");
    $(".store-details").find('.store-list .Grid__Cell[data-place-id="' + getPlaceID + '"]').addClass("found_store");
    $(".store-details").find('.store-list .Grid__Cell[data-place-id="' + getPlaceID + '"]').addClass("sFound");
    var getStoreHtml = $(".store-details").find('.store-list .Grid__Cell[data-place-id="' + getPlaceID + '"]');
    
    if ($("body").hasClass("temp_store")) {
      $(".store-details").find(".store-list .Grid").append(getStoreHtml);
      var getstorelength = $(".shopify-section .find-store .Grid__Cell.found_store:not(.hide)").length;
      getstorelength += getStoreHtml.length;
    }else{
      let storeHTML = "";
      var value_input = $("#bh-sl-address").val();
      // PinCode();
      var str = value_input;
      var numbers = str.match(/\b\d{6}\b/);
      if (numbers !== null) {
        numbers.forEach(function (number) {
          $("#bh-sl-address").val(number);
        });
      }

      document.querySelector('.store-details .Grid__Cell[data-place-id="' + getPlaceID + '"]')?.classList.remove("hide");
      storeHTML = decodeHTML(document.querySelector('.store-details .Grid__Cell[data-place-id="' + getPlaceID + '"]').outerHTML);
      document.querySelector('.store-details .Grid__Cell[data-place-id="' + getPlaceID + '"]').remove();
      document.querySelector('.store-details .Grid__Cell:last-child').outerHTML += storeHTML;
      
      // $(".store-details").find(".store-list1").append(getStoreHtml);
      // var store_lenw = $(".store-details").find(".store-list1").append(getStoreHtml);
      // var store_len = store_lenw.find(".store-list .Grid__Cell.found_store:not(.hide)").length;

      var getstorelength = $(".shopify-section .find-store .Grid__Cell.found_store:not(.hide)").length;
      getstorelength += getStoreHtml.length;
      if (store_length == 1) {
        $(".store_count").text(store_length + " store near you");
      } else {
        $(".store_count").text(store_length + " stores near you");
      }
      // setTimeout(function () {
      //   store_slider_fun();
      // }, 1000);
    }
    $(".store-details").find('.store-list .Grid__Cell[data-place-id="' + getPlaceID + '"]').removeClass("hide");
    // var getstorelength = $(".store-details").find('.store-list .Grid__Cell.found_store').length;
    if (getstorelength > 0) {
      $(".all-stores .filter").addClass("hide");
      $(".store-not_found, .why-visit").addClass("hide");
      $(".store-details").removeClass("hide");
      $(".shopify-section .find-store .store-found-text").removeClass("hide");
      $(".shopify-section .find-store .store-notfound-text").addClass("hide");
    } else {
      $(".all-stores .filter").removeClass("hide");
      $(".store-not_found, .why-visit").removeClass("hide");
      $(".store-details").addClass("hide");
      $(".shopify-section .find-store .store-found-text").addClass("hide");
      $(".shopify-section .find-store .store-notfound-text").removeClass("hide");
    }
  });
  if(lastIndex){
    // console.log("lastIndex",lastIndex);
    store_slider_fun();
  }

  setTimeout(function () {
    // set valu in url

    var inputVal = $(".input-find").val();
    if (currentUrl.indexOf("pinval=") !== -1) {
      newUrl = currentUrl.replace(/pinval=([^&]*)/,"pinval=" + encodeURIComponent(inputVal));
    } else {
      var separator = currentUrl.indexOf("?") !== -1 ? "&" : "?"; // Check if there are existing parameters
      newUrl = currentUrl + separator + "pinval=" + encodeURIComponent(inputVal);
    }
    $(".view_all").attr("href", newUrl);
    var value_input = $("#bh-sl-address").val();
    if (!isNaN(value_input)) {
      localStorage.customerPincode = value_input;
      manageHomeVisitForCD(value_input);
      $(".pinvlaue").text(value_input);
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
    } else if (current_pincode) {
      var value_input = current_pincode;
      localStorage.customerPincode = value_input;
      manageHomeVisitForCD(value_input);
      $(".pinvlaue").text(value_input);
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
    }
  }, 500);
  if (place) {
    if (Object.keys(place).length != 0) {
      var geocoder = new google.maps.Geocoder(); 
      var latitude = place.geometry.location.lat();
      var longitude = place.geometry.location.lng();
      geocoder.geocode({'latLng': new google.maps.LatLng(latitude, longitude)},function(results) {
      if (results[0].address_components) {
        var address = results[0].address_components;
        for (i = 0; i < address.length; ++i) {
          // do something with `substr[i]`
          addr = address[i];
          atype = addr.types;
          if (atype.includes("postal_code")) {
            current_pincode = addr.long_name;
          }
          if (atype.includes("country")) {
            country = addr.long_name;
          }
          if (atype.includes("administrative_area_level_1")) {
            state = addr.long_name;
          }
          if (atype.includes("administrative_area_level_3")) {
            city = addr.long_name;
          }         
        }
        handleGeocodeResults(city, state, country, current_pincode);
      }
    });
    }
  }

  function handleGeocodeResults(city, state, country, current_pincode) {
    // console.log("city",city)
    // console.log("state",state)
    // console.log("country",country)
    // console.log("current_pincode",current_pincode)
  
    // for API
    if (current_pincode == "") {
      current_pincode = value_input;
    }
    if ($(".notlogged").length > 0) {
      pinValues = {
        datetime: formatted,
        shopifyCustomerId: "",
        isGuest: true,
        pincodeNumber: current_pincode,
        lat: userLatitude,
        lng: userLongitude,
        city: city,
        state: state,
        country: country,
      };
    } else {
      pinValues = {
        datetime: formatted,
        shopifyCustomerId: fitsmartCustomerId,
        isGuest: false,
        pincodeNumber: current_pincode,
        lat: userLatitude,
        lng: userLongitude,
        city: city,
        state: state,
        country: country,
      };
    }
    // console.log("pinValues",pinValues)
    
    //api
    $.ajax({
      url: baseUrlBsc + "/pincode/save",
      type: "POST",
      data: JSON.stringify(pinValues),
      contentType: "application/json",
      dataType: "json",
      headers: requestToken,
      success: function (data, textStatus, xhr) {},
      complete: function (xhr, textStatus) {},
      error: function (err) {
        console.log(err);
      },
    });

    var kalviyoPinval
    var latlong = userLatitude + ' | ' + userLongitude;
    // console.log("dffdf",parseFloat(latlong))
    if ($(".notlogged").length > 0) {
      kalviyoPinval = {
        datetime: formatted,
        shopifyCustomerId: "",
        isGuest: true,
        pincodeNumber: current_pincode,
        latlong: latlong,
        city: city,
        state: state,
        country: country,
      };
    } else {
      kalviyoPinval = {
        datetime: formatted,
        shopifyCustomerId: fitsmartCustomerId,
        isGuest: false,
        pincodeNumber: current_pincode,
        latlong: latlong,
        city: city,
        state: state,
        country: country,
      };
    }
    // console.log("kalviyoPinval",kalviyoPinval)
    // kalviyo api
    // _learnq.push(["track", "Pincode_Search", kalviyoPinval]);

    // dataLayer.push({ ecommerce: null });
    // dataLayer.push({
    //   event: "Pincode_Search",
    //   user_type_event: loggedin,
    //   User_ID_event: user_id,
    //   ecommerce: {
    //     items: pinValues,
    //   },
    // });
  }
}
// end -- findstore

function noStoreFound_forPincodeBlock() {
  
  setTimeout(function () {
  var value_input = $("#bh-sl-address").val();
    
    if (!isNaN(value_input)) {
      localStorage.customerPincode = value_input;
      $(".pinvlaue").text(value_input);
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
    } else if (current_pincode) {
      var value_input = current_pincode;
      localStorage.customerPincode = value_input;
      $(".pinvlaue").text(value_input);
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
    }
  }, 500);
  $(`.filter-count-text`).html(`Stores Details`);
  $(".btn_name").addClass("hide");
  $(".search_close_icon").removeClass("hide");
  $(".all-stores .filter").addClass("hide");
  $(".why-visit").addClass("hide");
  $(".store-details").addClass("hide");
  $(".store-details").find(".store-list .Grid__Cell").removeClass("found_store");
  $(".store-not_found").removeClass("hide");
  $(".shopify-section .find-store .store-found-text").addClass("hide");
  $(".shopify-section .find-store .store-notfound-text").removeClass("hide");
  $(".store-not_found").find("p").text("No Nearby Stores Found");
  localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
  $(".store-details").find(".store-list .Grid__Cell").addClass("hide");
}

function findNearbyStores(userLatitude, userLongitude, maxDistance) {
  console.log("findNearbyStores",userLatitude,userLongitude,maxDistance);
  const nearbyStores = [];
  $(".store-list .Grid__Cell").each(function () {
    const storeLatitude = parseFloat($(this).attr("latitude"));
    const storeLongitude = parseFloat($(this).attr("longitude"));
    var place_id = $(this).attr("data-place-id");
    const distance = calculateDistance(userLatitude,userLongitude,storeLatitude,storeLongitude);
    if (distance <= maxDistance) {
      nearbyStores.push({place_id: place_id,distance: distance,});
    }
  });
  // console.log("findNearbyStores", nearbyStores);
  nearbyStores.sort(function (a, b) {
    return a.distance - b.distance;
  });
  // console.log("sorted", nearbyStores);
  return nearbyStores;
}

// Sample function to calculate distance using the Haversine formula
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers

  return distance;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

$("#bh-sl-address").keyup(function (event) {
  // alert("event",event.which);
  if(document.querySelector("body.stores")){
    $(".search_close_icon").addClass("hide");
    var searchValue = $(this).val();
    if (searchValue != "") {
      // $(".search_close_icon").removeClass("hide");
    } else {
      console.log("else");
      $(".all-stores .filter").removeClass("hide");
      $(".why-visit").removeClass("hide");
      // $(".store-details").find(".store-list .Grid__Cell").addClass("hide");
      $(".store-details").find(".store-list .Grid__Cell").removeClass("hide");
      $(".store-details").addClass("hide");
      $(".store-not_found").addClass("hide");
      $(".search_close_icon").addClass("hide");
      $(".current_location").removeClass("current-selected");
      $(".btn_name").removeClass("hide");
    }
  }else{
    var searchValue = $(this).val();
    searchValue = searchValue.replaceAll(",","")
    $(this).val(searchValue.replaceAll(".",""));
    if(event.which == 229){
      event.preventDefault();
      return false;
    }
    $(".serch-btn").removeClass("highlight");
    $(".serch-btn").addClass("changing");
    $(".btn_name").removeClass("hide");
    // var searchValue = $(this).val();
    if (searchValue != "") {
      // $(".search_close_icon").removeClass("hide");
    } else {
      $(".all-stores .filter").removeClass("hide");
      $(".why-visit").removeClass("hide");
      $(".store-details").find(".store-list .Grid__Cell").addClass("hide");
      $(".store-details").addClass("hide");
      $(".store-not_found").addClass("hide");
      $(".search_close_icon").addClass("hide");
      $(".current_location").removeClass("current-selected");
      // $(".btn_name").removeClass("hide");
    }
    if(searchValue.length != 6 && event.which == 13){
      let thisInput = $(this)[0];
      thisInput.blur();
      $(".serch-btn").trigger("click");
    }else if(searchValue.length == 6 && event.which == 13){
      $(".serch-btn").removeClass("changing");
      $(".btn_name").addClass("hide");
      let thisInput = $(this)[0];
      thisInput.blur();
      $(".serch-btn").trigger("click");
    }
  }
});
if(!document.querySelector("body.stores")){
  var inputPincodeBlock = document.getElementById("bh-sl-address");
  if(inputPincodeBlock){
    inputPincodeBlock.onkeydown = function(e) {
      // console.log("e",e);
      if ((48 > e.which || e.which > 57) && (96 > e.which || e.which > 105)){
        if (e.key.length === 1)
          e.preventDefault();
      }
    };
  }
}

if(document.body.classList.contains("temp_store")){
  // data-store-area-item
  $(document).on("click","[data-store-area-item]",function(e){
    e.preventDefault();
    localStorage.customerPincode = '';
    $(`#bh-sl-address`).val("");
    $('.search_close_icon').addClass("hide");
    document.body.classList.remove("city-dr-open");
    $(`[data-store-area-item].active`).removeClass("active");
    this.classList.add("active");
    if($(this).attr("data-store-area") != "all_stores"){
      $(".store-list .Grid__Cell").addClass("hide");
      $(`.store-list .Grid__Cell[data-store-area="${$(this).attr("data-store-area")}"]`).removeClass("hide");
      $(this).addClass("active").siblings().removeClass("active");
      let storeCount = $(`.store-list .Grid__Cell[data-store-area="${$(this).attr("data-store-area")}"]`).length;
      $(`.filter-count-text`).html(`${storeCount} store${storeCount != 1 ? "s":""} found in ${$(this).text()}`);
      // $(`[data-store-area-item][data-store-area="all_stores"]`).removeClass("active");
    }else{
      $(".store-list .Grid__Cell").removeClass("hide");
      let storeCount = $(`.store-list .Grid__Cell`).length;
      $(`.filter-count-text`).html(`${storeCount} STORES`);
      // $(`[data-store-area-item][data-store-area="all_stores"]`).addClass("active");
    }
    $(".store-not_found").addClass("hide");

    const target = document.querySelector('.store-list-popup');
    if (target) {
      const targetTop = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    }
    
  });

  // select city btn click for mobile
  $(".mob-city-btn button,.city-dr-colose").on("click", function(e){
    e.preventDefault(); // prevent link navigation if needed
    $("body").toggleClass("city-dr-open");
  });

  // $(".city-dr-colose").on("click", function(){
  //   $("body").removeClass("city-dr-open");
  // });
  
}

$(".search_close_icon, .all-stores .store-back-button").click(function (event) {
  console.log("event",event);
  if(document.querySelector("body.stores")){    
    $("#bh-sl-address").val("");
    $(".all-stores .filter").removeClass("hide");
    $(".why-visit").removeClass("hide");
    // $(".store-details").find(".store-list .Grid__Cell").addClass("hide");
    $(".store-details").find(".store-list .Grid__Cell").removeClass("hide");
    let storeCount = $(`.store-list .Grid__Cell`).length;
    $(`.filter-count-text`).html(`${storeCount} STORES`);
    $(`[data-store-area-item][data-store-area="all_stores"]`).addClass("active");
    $(".store-details").addClass("hide");
    $(".store-not_found").addClass("hide");
    $(".search_close_icon").addClass("hide");
    $(".current_location").removeClass("current-selected");
    $(".btn_name").removeClass("hide");
    localStorage.customerPincode = '';
  }else{
    $("#bh-sl-address").val("");
    $(".all-stores .filter").removeClass("hide");
    $(".why-visit").removeClass("hide");
    $(".store-details").find(".store-list .Grid__Cell").addClass("hide");
    $(".store-details").addClass("hide");
    $(".store-not_found").addClass("hide");
    $(".search_close_icon").addClass("hide");
    $(".current_location").removeClass("current-selected");
    $(".btn_name").removeClass("hide");
    // if(event.target.classList.contains("search_close_icon")) localStorage.customerPincode = "";
  }
});

window.initAutocomplete = initAutocomplete;

// if (
//   $("body").hasClass("temp_store") ||
//   $("body").hasClass("template-product") ||
//   $("body").hasClass("template-collection")
// ) {
// if(!document.body.classList.contains("temp_semi-appview-v2") && !document.body.classList.contains("temp_appview-v3") && !document.body.classList.contains("temp_picarioview")){
//   if (navigator.geolocation) {
//   // console.log("navigator.geolocation",navigator.geolocation);
//   window.navigator.geolocation.getCurrentPosition((position) => {
//     (latitude = position.coords.latitude),
//     (longitude = position.coords.longitude);
//     // console.log("latitude", latitude);
//     // console.log("longitude", longitude);
//   });
//   }
// }
// }

var latitude;
var longitude;
var service;

$(".current_location").click(function () {
  $(this).addClass("current-selected");
  // $(".btn_name").addClass("hide");
  $(".store-not_found").find("p").text("Uh-oh! We are yet to provide in-store experience near your current location.");
  var timeoutValue = 1000; // 10 seconds

  // Request the user's location
  navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
    enableHighAccuracy: true,
    timeout: timeoutValue,
  });

  if (window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition((position) => {
      (latitude = position.coords.latitude),(longitude = position.coords.longitude);
      // $("#bh-sl-address").val('Your location');
      var result;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({latLng: new google.maps.LatLng(latitude, longitude),},function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          //console.log("georesult",results);
          dispaly_stores(results[0], "", "");
          $.each(results[0].address_components, function (i, val) {
            if (val.types[0] == "postal_code") {
              var current_pincode = val.short_name;
              $("#bh-sl-address").val(current_pincode);
              return false;
            }
          });
        }
      });

      $(".search_close_icon").removeClass("hide");
      $(".btn_name").addClass("hide");
      $(".serch-btn").addClass("highlight");
      const currentPosition = new google.maps.LatLng(latitude, longitude); // Replace with actual coordinates
      // console.log("currentPosition", currentPosition);
      // console.log("use_latitude", latitude);
      // console.log("use_longitude", longitude);

      function initialize() {
        var request = {
          location: {
            lat: latitude,
            lng: longitude,
          },
          radius: "50000",
          type: ["clothing_store" | "store"],
          keyword: "Bombay Shirt Company",
        };
        // console.log("request", result);
        var place = {};
        //dispaly_stores(place, latitude, longitude);
      }

      initialize();
      $(".all-stores").find(".filter").addClass("hide");
    });
  }else{
    // $(".search_close_icon").removeClass("hide");
    // btn_name
    $(".btn_name").removeClass("hide");
  }
});

$(".location-filter").find(".sort-location").each(function () {
    var getValue = $(this).attr("data-value");
    var size_count = [];
    $(".store-list").find(".Grid__Cell").each(function (index) {
        var store_list_Value = $(this).attr("data-store-area");
        if (getValue == store_list_Value) {
          size_count.push(store_list_Value);
        }
      });
    if (size_count.length > 1) {
      $(this).find(".store-count").text(size_count.length + " stores");
    } else {
      $(this).find(".store-count").text(size_count.length + " store");
    }
  });

// console.time("time1");
$(".store-list").find(".Grid__Cell").each(function (index) {
  $(this).find(".share-add.desktop_").click(function () {
      $("body").addClass("show-share-pop");
      var geturl = $(this).closest(".Grid__Cell").find(".store-map .copytext").text();
      $(".desk-share-popup").find(".share-options .cpy").attr("data-url", geturl);
      // console.log("geturl",geturl);
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 768) {
        $(".desk-share-popup").find(".share-options .wa").attr("href",`https://api.whatsapp.com/send?phone=&text=${geturl}`);
      } else {
        $(".desk-share-popup").find(".share-options .wa").attr("href",`https://web.whatsapp.com/send?phone=&text=${geturl}`);
      }
    });
});

$(".desk-share-popup").find(".cpy").click(function () {
  var temp = $("<input>");
  $("body").append(temp);
  temp.val($(this).attr("data-url")).select();
  document.execCommand("copy");
  temp.remove();
  // console.timeEnd('time1');
  let copySuccess = document.getElementById("copied-success");
  copySuccess.style.opacity = "1";
  setTimeout(function () {
    copySuccess.style.opacity = "0";
  }, 500);
});

$(".desk-share-popup").find(".close_").click(function () {
  $("body").removeClass("show-share-pop");
});

$(".footer_filter").find("li").each(function (index) {
  $(this).click(function () {
    $(this).addClass("active").siblings().removeClass("active");
  });
});

function successCallback(position) {
  // console.log("position",position);
}

function errorCallback(error) {
  // Handle errors here
  switch (error.code) {
    case error.PERMISSION_DENIED:
      // alert("User denied the request for Geolocation.");
      alert("You have blocked Bombayshirts from accessing your location. To use this, change your location settings in the browser.");
      break;
    case error.POSITION_UNAVAILABLE:
      alert("Location information is unavailable.");
      break;
    case error.TIMEOUT:
      alert("Location timed out.");
      break;
    default:
      alert("An unknown error occurred.");
      break;
  }
}

// popup for pincode
// $(".input-find_popup").on("input", function () {
//   console.log("input-find_popup input");
//   var typedValue = $(this).val().trim();
//   if (typedValue !== "") {
//     $(".serch_btn_popup").addClass("highlight");
//     // console.log("1")
//   } else {
//     $(".serch_btn_popup").removeClass("highlight");
//     // console.log("12")
//   }
// });

// pincode section block btn click event
$('.serch-btn,.search_icon-submit').click(function(e) {
  console.log("btn clicked",$(this).find('.btn_name:not(.hide)').length);
  // prevent to click when input is blanked
  if($('#bh-sl-address').val() == '' && $(this).find('.btn_name:not(.hide)').length > 0){
    return false;
  }
  // console.log("event",e);
  if(document.querySelector("body.stores")){
    if($(`#bh-sl-address`).val() != ""){
    document.body.classList.remove("city-dr-open");
    $('.input-find').val('');
    $('.serch-btn').removeClass('highlight');
    geocoder = new google.maps.Geocoder();
    let pincode = $("#bh-sl-address").val();
    // console.log("clicked");
    geocoder.geocode({ 'address': pincode }, function (results, status) {
      console.log(results,"status",status);
      if(results != null && results.length > 0){
        dispaly_stores(results[0]);
      }else{
        noStoreFound_forPincodeBlock();
      }
    });
    }
  }else{
    if(e.target.classList.contains("search_close_icon")) return;
    $('.serch-btn').removeClass('highlight');
    $('.serch-btn').removeClass('changing');
    $('.serch-btn .btn_name').addClass("hide");
    $('.search_close_icon').removeClass("hide");
    geocoder = new google.maps.Geocoder();
    let pincode = $("#bh-sl-address").val();
    // console.log("clicked");
    geocoder.geocode({ 'address': pincode }, function (results, status) {
      console.log(results,"status",status);
      if(results != null && results.length > 0){
        dispaly_stores(results[0]);
      }else{
        noStoreFound_forPincodeBlock();
      }
    });
  }
});

let counterP = 1;
let oneTimeCode = setInterval(() => {
  $(".input-find,.input-find_popup").attr("autocomplete","one-time-code");
  counterP++;
  // if($(".input-find").attr("autocomplete") != "off"){
  if(counterP == 5){
    clearInterval(oneTimeCode);
  }
},500);

// pincode section block search input
if(document.querySelector("body.stores")){
  $(".input-find").on("input", function () {
    var typedValue = $(this).val().trim();
    if (typedValue !== "") {
      $(".serch_btn").addClass("highlight");
    } else {
      $(".serch_btn").removeClass("highlight");
    }
  });
}

// pincode popup search input
$(".serch_btn_popup").click(function (e) {
  // console.log("event",e);
  if(e.target.classList.contains("close_icon_search")) return;
  // $(".input-find_popup").val("");
  $(".serch_btn_popup").removeClass("highlight");
  
  $(".serch_btn_popup .close_icon_search").removeClass("hide");
  $(".serch_btn_popup").removeClass("changing");
  $(".btn_name_popup").addClass("hide");
  geocoder = new google.maps.Geocoder();
  let pincode = $("#store_input").val();
  geocoder.geocode({ 'address': pincode }, function (results, status) {
    // console.log(results,status);
    if(results != null && results.length > 0){
      dispaly_stores1(results[0]);
    }else{
      noStoreFound_forPopup();
    }
  });
});

var latitude;
var longitude;
var service;
var currentPosition;

var customer_pincode = $(".customer_pincode").text();

var loclPinval = localStorage.getItem("customerPincode");
if (loclPinval) {
  var pincodeinput = loclPinval;
  // console.log("1")
} else {
  if (customer_pincode) {
    var pincodeinput = customer_pincode;
    // localStorage.customerPincode = pincodeinput;
    // console.log("2")
  } else if (loclPinval) {
    var pincodeinput = loclPinval;
    // console.log("3")
  }
}

function popupPicode() {
  var pincodeinput = localStorage.getItem("customerPincode");
  var geocoder = new google.maps.Geocoder();
  geocoder.geocode(
    {
      address: pincodeinput,
    },
    function (results) {
      if(results){
        var place = {
          location: {
            lat: latitude,
            lng: longitude,
          },
          radius: "50000",
          type: ["clothing_store" | "store"],
          keyword: "Bombay Shirt Company",
        };
        // console.log("results", results);
        var latitude = results[0].geometry.location.lat();
        var longitude = results[0].geometry.location.lng();
        var place = {};
        // dispaly_stores1(place, latitude, longitude);
        dispaly_stores(place, latitude, longitude);
      }else{
        noStoreFound_forPincodeBlock();
      }
    }
  );
}

// for popup
function initAutocomplete1() {
  // // console.log("initAutocomplete1");
  // const map1 = new google.maps.Map(document.createElement("div"));
  // const input1 = document.getElementById("store_input");
  // const searchBox1 = new google.maps.places.SearchBox(input1);

  // function placesChangedListener() {
  //   const places = searchBox1.getPlaces();
  //   // console.log("Place", places);
  //   if (places.length == 0) {
  //     return;
  //   }

  //   places.forEach((place) => {
  //     // console.log("place", place);
  //     if (place) {
  //       // $(".search_close_icon").removeClass("hide");
  //       $(".current_location").removeClass("current-selected");
  //     }
  //     dispaly_stores1(place);
  //   });
  // }
  // searchBox1.addListener("places_changed", placesChangedListener);
}

function dispaly_stores1(place, userLatitude = "", userLongitude = "") {
  // console.log("dispaly_stores1");
  var current_pincode;
  var country;
  var state;
  var city;
  var address = place?.address_components;
  // console.log("address",address)

  if (userLatitude == "") {
    // console.log("in length");
    var userLatitude = place?.geometry.location.lat();
    var userLongitude = place?.geometry.location.lng();
  }
  var maxDistance = 50;
  const nearbyStores = findNearbyStores1(userLatitude,userLongitude,maxDistance);
  // console.log("nearbyStores>>>>>>>>",nearbyStores);
  if (nearbyStores.length > 0) {
    // console.log("add hide class");
    $(".store-details_popup").find(".store-list-main .Grid__Cell_popup").addClass("hide");
    $(".store-popup-header.find-store .store-found-text").removeClass("hide");
    $(".store-popup-header.find-store .store-notfound-text").addClass("hide");
    // console.log(nearbyStores);
    $(".btn_name_popup").addClass("hide");
    $(".serch_btn_popup").removeClass("changing");
    
  } else {
    // console.log("remove add class");
    $(".all-stores .filter").addClass("hide");
    $(".why-visit").addClass("hide");
    $(".store-details_popup").addClass("hide");
    document.body.classList.add("store_result");
    if($(".store_result .store-details_popup:not(.hide)").length){
      document.body.classList.add("result_0");
    }else{
      document.body.classList.remove("result_0");
    }
    $(".store-details_popup").find(".store-list-main .Grid__Cell_popup").removeClass("found_store");
    $(".notfound-text-popup").removeClass("hide");
    $(".btn_name_popup").addClass("hide");
    $(".close_icon_search").removeClass("hide");
    $(".store-popup-header.find-store .store-found-text").addClass("hide");
    $(".store-popup-header.find-store .store-notfound-text").removeClass("hide");

    var value_input = $("#store_input").val();
    // console.log("value_input", value_input);

    var str = value_input;
    var numbers = str.match(/\b\d{6}\b/);
    if (numbers !== null) {
      numbers.forEach(function (number) {
        // console.log(number,"number111");
        $("#store_input").val(number);
        if (!isNaN(value_input)) {
          localStorage.customerPincode = number;
          $(".pinvlaue").text(number);
          $(".pincode_text").addClass("hide");
          $(".pincode_number").removeClass("hide");
        }else if (current_pincode) {
        var value_input = current_pincode;
        localStorage.customerPincode = value_input;
        $(".pinvlaue").text(value_input);
        $(".pincode_text").addClass("hide");
        $(".pincode_number").removeClass("hide");
      }
      });
    }
  }

  let scrollCounter = false;
  nearbyStores.forEach((place, index) => {
    if(index == (nearbyStores.length - 1)){
      allowForScroll = true;
      scrollCounter = true;
      // console.log("last indexxxxxxxxxx",allowForScroll);
    }
    // console.log(place.place_id);
    var getPlaceID = place.place_id;
    var store_length = nearbyStores.length;

    $(".store-popup-header .found-text").removeClass("changing");
    $(".store-details_popup").removeClass("hide");
    document.body.classList.remove("store_result");
    $(".btn_name_popup").addClass("hide");
    $(".close_icon_search").removeClass("hide");
    $(".store-details_popup").find('.store-list-main .Grid__Cell_popup[data-place-id="' + getPlaceID + '"]').addClass("found_store");
    $(".store-details_popup").find('.store-list-main .Grid__Cell_popup[data-place-id="' + getPlaceID + '"]').addClass("sFound");
    var getStoreHtml = $(".store-details_popup").find('.store-list-main .Grid__Cell_popup[data-place-id="' + getPlaceID + '"]');

    var value_input = $("#store_input").val();
    // PinCode();

    var str = value_input;
    var numbers = str.match(/\b\d{6}\b/);
    if (numbers !== null) {
      numbers.forEach(function (number) {
        $("#store_input").val(number);
      });
    }
    $(".store-details_popup").find(".store_list_popup").append(getStoreHtml);
    var store_lenw = $(".store-details_popup").find(".store_list_popup").append(getStoreHtml);

    var store_len = store_lenw.find(".store-list-main .Grid__Cell_popup.found_store:not(.hide)").length;
    var getstorelength = $(".store-details_popup").find(".store-list-main .Grid__Cell_popup.found_store:not(.hide)").length;
    getstorelength += getStoreHtml.length;
    // if (store_length == 1) {
    //   $(".store_count_popup").text(store_length + " store near you");
    // } else {
    //   $(".store_count_popup").text(store_length + " stores near you");
    // }
    if (getstorelength == 1) {
      $(".store_count_popup").text(getstorelength + " store near you");
    } else {
      $(".store_count_popup").text(getstorelength + " stores near you");
    }

    $(".store-details_popup").find('.store-list-main .Grid__Cell_popup[data-place-id="' + getPlaceID + '"]').removeClass("hide");
    if (getstorelength > 0) {
      $(".all-stores .filter").addClass("hide");
      $(".notfound-text-popup").addClass("hide");
      $(".store-details_popup").removeClass("hide");
      document.body.classList.remove("store_result");
      $(".store-popup-header.find-store .store-found-text").removeClass("hide");
      $(".store-popup-header.find-store .store-notfound-text").addClass("hide");
    } else {
      $(".all-stores .filter").removeClass("hide");
      $(".store-details_popup").addClass("hide");
      document.body.classList.add("store_result");
      if($(".store_result .store-details_popup:not(.hide)").length){
        document.body.classList.add("result_0");
      }else{
        document.body.classList.remove("result_0");
      }
      $(".notfound-text-popup").removeClass("hide");
      $(".store-popup-header.find-store .store-found-text").addClass("hide");
      $(".store-popup-header.find-store .store-notfound-text").removeClass("hide");
    }
  });
  
  // setTimeout(function () {
  //   store_slider_fun_popup();
  // }, 1000);
  // console.log("forloopEND");
  // if(window.innerHeight <= 683){
  if(scrollCounter == true){
    scrollCounter = false;
    store_slider_fun_popup();
    if(document.querySelector(".store-popup-header.find-store")){
      // console.log("inside",document.querySelector(".store-popup-header.find-store").scrollHeight);
      // document.querySelector(".store-popup-header.find-store").scrollTo(0,window.innerHeight);
      document.querySelector(".store-popup-header.find-store").scrollTo(0,1500);
    }
  }
  // }

  setTimeout(function () {
    var inputVal = $(".input-find_popup").val();
    // console.log("2", inputVal);
    if (!isNaN(inputVal)) {
      localStorage.customerPincode = inputVal;
    }
    if (currentUrl.indexOf("pinval=") !== -1) {
      newUrl = currentUrl.replace(/pinval=([^&]*)/,"pinval=" + encodeURIComponent(inputVal));
    } else {
      var separator = currentUrl.indexOf("?") !== -1 ? "&" : "?"; // Check if there are existing parameters
      newUrl = currentUrl + separator + "pinval=" + encodeURIComponent(inputVal);
    }
    $(".view_all_popup").attr("href", newUrl);
    var input_number = $("#store_input").val();
    if (!isNaN(value_input)) {
      localStorage.customerPincode = input_number;
      $(".pinvlaue").text(input_number);
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
    }else if (current_pincode) {
      var value_input = current_pincode;
      localStorage.customerPincode = value_input;
      $(".pinvlaue").text(value_input);
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
    }
  }, 500);

  if (place) {
    // console.log("place",place)
    // console.log("place_length",Object.keys(place).length)
    if (Object.keys(place).length != 0) {
      var geocoder = new google.maps.Geocoder(); 
      var latitude = place.geometry.location.lat();
      var longitude = place.geometry.location.lng();
      geocoder.geocode({'latLng': new google.maps.LatLng(latitude, longitude)},function(results) {
      if (results[0].address_components) {
        var address = results[0].address_components;
        for (i = 0; i < address.length; ++i) {
          // do something with `substr[i]`
          addr = address[i];
          atype = addr.types;
          if (atype.includes("postal_code")) {
            current_pincode = addr.long_name;
          }
          if (atype.includes("country")) {
            country = addr.long_name;
          }
          if (atype.includes("administrative_area_level_1")) {
            state = addr.long_name;
          }
          if (atype.includes("administrative_area_level_3")) {
            city = addr.long_name;
          }         
        }
        handleGeocodeResults(city, state, country, current_pincode);
      }
      });
    }
  }

  function handleGeocodeResults(city, state, country, current_pincode) {
    // console.log("city",city)
    // console.log("state",state)
    // console.log("country",country)
    // console.log("current_pincode",current_pincode)
    // for API
    if (current_pincode == "") {
      current_pincode = value_input;
    }
    if ($(".notlogged").length > 0) {
      pinValues = {
        datetime: formatted,
        shopifyCustomerId: "",
        isGuest: true,
        pincodeNumber: current_pincode,
        lat: userLatitude,
        lng: userLongitude,
        city: city,
        state: state,
        country: country,
      };
    } else {
      pinValues = {
        datetime: formatted,
        shopifyCustomerId: fitsmartCustomerId,
        isGuest: false,
        pincodeNumber: current_pincode,
        lat: userLatitude,
        lng: userLongitude,
        city: city,
        state: state,
        country: country,
      };
    }
    // // console.log("pinValues",pinValues)
    
    //api
    $.ajax({
      url: baseUrlBsc + "/pincode/save",
      type: "POST",
      data: JSON.stringify(pinValues),
      contentType: "application/json",
      dataType: "json",
      headers: requestToken,
      success: function (data, textStatus, xhr) {},
      complete: function (xhr, textStatus) {},
      error: function (err) {
        console.log(err);
      },
    });

    var kalviyoPinval
    var latlong = userLatitude + ' | ' + userLongitude;
    if ($(".notlogged").length > 0) {
      kalviyoPinval = {
        datetime: formatted,
        shopifyCustomerId: "",
        isGuest: true,
        pincodeNumber: current_pincode,
        latlong: latlong,
        city: city,
        state: state,
        country: country,
      };
    } else {
      kalviyoPinval = {
        datetime: formatted,
        shopifyCustomerId: fitsmartCustomerId,
        isGuest: false,
        pincodeNumber: current_pincode,
        latlong: latlong,
        city: city,
        state: state,
        country: country,
      };
    }
    // // console.log("kalviyoPinval",kalviyoPinval)
    // kalviyo api
    // _learnq.push(["track", "Pincode_Search", kalviyoPinval]);
    // dataLayer.push({ ecommerce: null });
    // dataLayer.push({
    //   event: "Pincode_Search",
    //   user_type_event: loggedin,
    //   User_ID_event: user_id,
    //   ecommerce: {
    //     items: pinValues,
    //   },
    // });
  }
}
// end -- dispaly_stores1

function noStoreFound_forPopup(){
  // console.log("remove add class");
  $(".all-stores .filter").addClass("hide");
  $(".why-visit").addClass("hide");
  $(".store-details_popup").addClass("hide");
  document.body.classList.add("store_result");
  if($(".store_result .store-details_popup:not(.hide)").length){
  document.body.classList.add("result_0");
  }else{
  document.body.classList.remove("result_0");
  }
  $(".store-details_popup").find(".store-list-main .Grid__Cell_popup").removeClass("found_store");
  $(".notfound-text-popup").removeClass("hide");
  $(".btn_name_popup").addClass("hide");
  $(".close_icon_search").removeClass("hide");
  $(".store-popup-header.find-store .store-found-text").addClass("hide");
  $(".store-popup-header.find-store .store-notfound-text").removeClass("hide");
  
  var value_input = $("#store_input").val();
  // console.log("value_input", value_input);
  
  var str = value_input;
  var numbers = str.match(/\b\d{6}\b/);
  if (numbers !== null) {
    numbers.forEach(function (number) {
    // console.log(number,"number111");
    $("#store_input").val(number);
    if (!isNaN(value_input)) {
    localStorage.customerPincode = number;
    $(".pinvlaue").text(number);
    $(".pincode_text").addClass("hide");
    $(".pincode_number").removeClass("hide");
    }else if (current_pincode) {
    var value_input = current_pincode;
    localStorage.customerPincode = value_input;
    $(".pinvlaue").text(value_input);
    $(".pincode_text").addClass("hide");
    $(".pincode_number").removeClass("hide");
    }
    });
  }
}

function findNearbyStores1(userLatitude, userLongitude, maxDistance) {
  console.log("findNearbyStores1");
  const nearbyStores = [];
  $(".store-list-main .Grid__Cell_popup").each(function () {
    const storeLatitude = parseFloat($(this).attr("latitude"));
    const storeLongitude = parseFloat($(this).attr("longitude"));
    var place_id = $(this).attr("data-place-id");

    const distance = calculateDistance(userLatitude,userLongitude,storeLatitude,storeLongitude);
    if (distance <= maxDistance) {
      nearbyStores.push({
        place_id: place_id,
        distance: distance,
      });
    }
  });
  // console.log("findNearbyStores", nearbyStores);
  nearbyStores.sort(function (a, b) {
    return a.distance - b.distance;
  });
  // console.log("sorted", nearbyStores);
  return nearbyStores;
}
$(".store-popup-header").scroll(function(){
  // console.log("store-popup-header scrollled");
  $(".pac-container.pac-logo").hide()
});

$(".content-header").click(function(){
  console.log("content-header clicked");
});
$("#store_input").keyup(function (event) {
  var searchValue = $(this).val();
  searchValue = searchValue.replaceAll(",","")
  $(this).val(searchValue.replaceAll(".",""));
  if(event.which == 229){
    event.preventDefault();
    return false;
  }
  $(".serch_btn_popup").removeClass("highlight");
  // if(event.which != 13){
    $(".btn_name_popup").removeClass("hide");
    $(".serch_btn_popup").addClass("changing");
  // }

  if (searchValue != "") {
    // $(".btn_name_popup").addClass("hide");
  } else {
    $(".all-stores .filter").removeClass("hide");
    $(".why-visit").removeClass("hide");
    $(".store-details_popup").find(".store-list-main .Grid__Cell_popup").addClass("hide");
    $(".store-details_popup").addClass("hide");
    document.body.classList.add("store_result");
    if($(".store_result .store-details_popup:not(.hide)").length){
      document.body.classList.add("result_0");
    }else{
      document.body.classList.remove("result_0");
    }
    $(".close_icon_search").addClass("hide");
    $(".notfound-text-popup").addClass("hide");
    $(".current_location_popup").removeClass("current_selected_popup");
    // $(".btn_name_popup").removeClass("hide");
  }
  if(searchValue.length != 6 && event.which == 13){
    let thisInput = $(this)[0];
    thisInput.blur();
    $(".serch_btn_popup").trigger("click");
  }else if(event.which == 13){
    $(".btn_name_popup").addClass("hide");
    $(".serch_btn_popup").removeClass("changing");
    
    let thisInput = $(this)[0];
    thisInput.blur();
    $(".serch_btn_popup").trigger("click");
  }
});

var inputPincodePopup = document.getElementById("store_input");
if(inputPincodePopup){
  inputPincodePopup.onkeydown = function(e) {
    // console.log(`which=>${e.which}`);
    if(e.which == 229){
      e.preventDefault();
      return true;
    }else{
      if ((48 > e.which || e.which > 57) && (96 > e.which || e.which > 105)){
        if (e.key.length === 1){
          e.preventDefault();
          return false;
        }
      }
    }
  };
}

$(".close_icon_search").click(function (event) {
  // console.log('close clicked');
  $("#store_input").val("");
  $(".all-stores .filter").removeClass("hide");
  $(".notfound-text-popup").addClass("hide");
  $(".why-visit").removeClass("hide");
  $(".store-details_popup").find(".store-list-main .Grid__Cell_popup").addClass("hide");
  $(".store-details_popup").addClass("hide");
  document.body.classList.add("store_result");
  if($(".store_result .store-details_popup:not(.hide)").length){
    document.body.classList.add("result_0");
  }else{
    document.body.classList.remove("result_0");
  }
  $(".close_icon_search").addClass("hide");
  $(".current_location_popup").removeClass("current_selected_popup");
  $(".btn_name_popup").removeClass("hide");
});

var latitude;
var longitude;
var service;
$(".current_location_popup").click(function () {
  $(this).addClass("current_selected_popup");
  var input_popup = $("#store_input").val();
  $(".serch_btn_popup").removeClass("changing");
  // if (input_popup == "") {
  //   $(".btn_name_popup").removeClass("hide");
  // } else {
  //   $(".btn_name_popup").addClass("hide");
  // }
  var timeoutValue = 1000; // 10 seconds != '')
  // Request the user's location
  navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
    enableHighAccuracy: true,
    timeout: timeoutValue,
  });
  if (window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition((position) => {
      (latitude = position.coords.latitude),
        (longitude = position.coords.longitude);
      // $("#store_input").val('Your location');

      // Use the Google Maps Geocoding API to get the address
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({latLng: new google.maps.LatLng(latitude, longitude),},function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
             dispaly_stores1(results[0], "", "");
            $.each(results[0].address_components, function (i, val) {
              if (val.types[0] == "postal_code") {
                // console.log("short_name",val.short_name)
                var current_pincode = val.short_name;
                $("#store_input").val(current_pincode);
                if (!isNaN(current_pincode)) {
                  localStorage.customerPincode = current_pincode;
                }
                return false;
              }
            });
          } else {
            // Handle the error
            alert("Error getting your pincode: " + status);
          }
        }
      );
      $(".btn_name_popup").addClass("hide");
      $(".close_icon_search").removeClass("hide");
      const currentPosition = new google.maps.LatLng(latitude, longitude); // Replace with actual coordinates

      function initialize1() {
        var request = {
          location: {
            lat: latitude,
            lng: longitude,
          },
          radius: "50000",
          type: ["clothing_store" | "store"],
          keyword: "Bombay Shirt Company",
        };

        var place = {};
        //dispaly_stores1(place, latitude, longitude);
      }

      initialize1();
      $(".all-stores").find(".filter").addClass("hide");
    });
  }
});

$(window).on("load", function () {
  // Check if the popup should be displayed or not
  if ($("body").hasClass("template-index")) {
    if (localStorage.popupstore) {
      if ((localStorage.popupstore - Date.now()) / (1000 * 60 * 60 * 24 * 2) >= 1) {
        setTimeout(function () {
          $(".store-popup-header").fadeIn("slow");
          $(".store-popup-header").removeClass("hide");
          $("body").addClass("show_pin_popup");
          var customer_pincode = $(".customer_pincode").text();
          var loclPinval = localStorage.getItem("customerPincode");
          if (loclPinval) {
            $("#store_input").val(loclPinval);
            popupPicode();
          } else {
            if (customer_pincode) {
              $("#store_input").val(customer_pincode);
              popupPicode();
            } else {
              $("#store_input").val(loclPinval);
              popupPicode();
            }
          }
          initAutocomplete1();
        }, 2000);
      }
    } else {
      // setTimeout(function () {
      //   $(".store-popup-header").fadeIn("slow");
      //   $(".store-popup-header").removeClass("hide");
      //   $("body").addClass("show_pin_popup");
      //   var customer_pincode = $(".customer_pincode").text();
      //   var loclPinval = localStorage.getItem("customerPincode");
      //   if (loclPinval) {
      //     $("#store_input").val(loclPinval);
      //     popupPicode();
      //   } else {
      //     if (customer_pincode) {
      //       $("#store_input").val(customer_pincode);
      //       popupPicode();
      //     } else {
      //       $("#store_input").val(loclPinval);
      //       popupPicode();
      //     }
      //   }
      //   initAutocomplete1();
      // }, 2000);
    }
  }
});

var smallScreen = window.matchMedia("(max-width: 767px)");
if (smallScreen.matches) {
  $(".pincode").on("click", function () {
    // Display the popup when the pincode is clicked
    var customer_pincode = $(".customer_pincode").text();
    var loclPinval = localStorage.getItem("customerPincode");
    if (loclPinval) {
      $("#store_input").val(loclPinval);
      popupPicode();
    } else {
      if (customer_pincode) {
        $("#store_input").val(customer_pincode);
        popupPicode();
      } else {
        $("#store_input").val(loclPinval);
        popupPicode();
      }
    }
    initAutocomplete1();
    $(".store-popup-header").fadeIn("slow");
    $(".store-popup-header").removeClass("hide");
    $("body").addClass("show_pin_popup");
    let counterPopup = 1;
    let oneTimeCode1 = setInterval(() => {
      $(".input-find,.input-find_popup").attr("autocomplete","one-time-code");
      counterPopup++;
      // if($(".input-find").attr("autocomplete") != "off"){
      if(counterPopup == 5){
          clearInterval(oneTimeCode);
      }
    },500);
  });
} else {
  $(".pincode").on("click", function () {
    var customer_pincode = $(".customer_pincode").text();
    // Display the popup when the pincode is clicked
    var loclPinval = localStorage.getItem("customerPincode");
    // console.log(loclPinval)
    // $('#store_input').val(loclPinval);
    if (loclPinval) {
      $("#store_input").val(loclPinval);
      popupPicode();
    } else {
      if (customer_pincode) {
        $("#store_input").val(customer_pincode);
        popupPicode();
      } else {
        $("#store_input").val(loclPinval);
        popupPicode();
      }
    }
    initAutocomplete1();
    $(".store-popup-header").fadeIn("slow");
    $(".store-popup-header").removeClass("hide");
    $("body").addClass("show_pin_popup");
    let counterPopup = 1;
    let oneTimeCode1 = setInterval(() => {
      $(".input-find,.input-find_popup").attr("autocomplete","one-time-code");
      counterPopup++;
      // if($(".input-find").attr("autocomplete") != "off"){
      if(counterPopup == 5){
          clearInterval(oneTimeCode);
      }
    },500);
  });
}

$(document).ready(function () {
  var customer_pincode = $(".customer_pincode").text();
  // $('.pincode_text').addClass('hide');
  // $('.pincode_number').removeClass('hide');
  // $('.pinvlaue').text(loclPinval);
  if (loclPinval) {
    $(".pincode_text").addClass("hide");
    $(".pincode_number").removeClass("hide");
    $(".pinvlaue").text(loclPinval);
  } else {
    if (customer_pincode) {
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
      $(".pinvlaue").text(customer_pincode);
    } else if (loclPinval) {
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
      $(".pinvlaue").text(loclPinval);
    } else {
      $(".pincode_text").removeClass("hide");
      $(".pincode_number").addClass("hide");
    }
  }
});

$(".close_add,.pin-overlay").on("click", function () {
  $(".store-popup-header").addClass("hide");
  $("body").removeClass("show_pin_popup");
  localStorage.popupstore = Date.now();
  var loclPinval = localStorage.getItem("customerPincode");
  // console.log("loclPinsssval",loclPinval);
  // console.log($('#store_input').val(),"dhhddh")
  if (loclPinval) {
    $(".pincode_text").addClass("hide");
    $(".pincode_number").removeClass("hide");
    $(".pinvlaue").text(loclPinval);
  } else {
    if (customer_pincode) {
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
      $(".pinvlaue").text(customer_pincode);
    } else if (loclPinval) {
      $(".pincode_text").addClass("hide");
      $(".pincode_number").removeClass("hide");
      $(".pinvlaue").text(loclPinval);
    } else {
      $(".pincode_text").removeClass("hide");
      $(".pincode_number").addClass("hide");
    }
  }
});

// $(`a[target="_blank"][href*="/collections/"]`).removeAttr("target");
// if(!document.body.classList.contains("template-collection")){
//   $(`a[target="_blank"]`).removeAttr("target");
// }

// data-login-privacy-checkbox
let loginPrivacyCheckbox = document.querySelector("[data-login-privacy-checkbox]") || null;
if(loginPrivacyCheckbox){
  loginPrivacyCheckbox.addEventListener("change",function(e){
    e.preventDefault();
    // console.log("this",this.checked);
    let sendOtp = document.querySelector(".send-btn.otp-btn") || null;
    if(sendOtp){
      if(this.checked){
        sendOtp.classList.remove("disabled");
      }else{
        sendOtp.classList.add("disabled");
      }
    }
  });
}

// featured gift card profuct -- add to  cart
let giftCardA2c = document.querySelector("[data-featured-gift-product-btn]") || null;
if(giftCardA2c){
  giftCardA2c.addEventListener("click",function(e) {
    e.preventDefault();
    // console.log("clicked",this);
    let proObj = {};
    proObj.id = giftCardA2c.closest(".FeaturedProduct__Info").querySelector(`form [name="id"]`).value;
    proObj.quantity = parseInt(giftCardA2c.closest(".FeaturedProduct__Info").querySelector(`form [name="quantity"]`).value);
    // console.log("proObj",proObj);
    productCardAdd2Cart(proObj);
  });
}

let featuredGiftProductCloseBtns = document.querySelectorAll(".father-day-featured-product .Popup__Dismiss.Great__ChoiseDismiss, .father-day-featured-product .continue__shopping_link");
featuredGiftProductCloseBtns.forEach(closeBtn => {
  closeBtn.addEventListener("click",function(e){
    e.preventDefault();
    document.body.classList.remove("gift-success");
  });
});

function productCardAdd2Cart(proObj) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { "Accept": "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(proObj)
  })
  .then(response => response.json()).then(response => {
    // console.log(response);
    var getPrice = response.variant_title;
    document.body.classList.add("gift-success");
    // console.log("getPrice",getPrice);
    setTimeout(function(){
      document.querySelector(".gift-cart-success .selected-item-price .money").innerHTML = getPrice;
      updateCustomerCartId();
    },300);
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally((e) => {
    // console.log("finally");
  });
}
/*
=================================================
Membership page - MEMBERSHIP ======> START
=================================================
*/
let membershipBtns = document.querySelectorAll("[data-membership-a2c-btn]") || null;
if(membershipBtns.length > 0 && document.body.classList.contains("temp_membership")){
  membershipBtns.forEach(btn => {
    btn.addEventListener("click",function(e){
      e.preventDefault();
      // console.log("clicked");
      let pro = {};
      pro.id = Number(this.dataset.variant);
      pro.quantity = 1;
      pro.properties = {};
      pro.properties["_productType"] = "membership";
      pro.properties["_date_subscribe"] = new Date().valueOf();
      // console.log("pro",pro);
      membershipProduct(pro);
    });
  });
}

// for cart page btn click event
if(document.body.classList.contains("template-cart")){
  // membershipBtns.forEach(btn => {
    $(document).on("click","[data-membership-a2c-btn]",function(e){
      e.preventDefault();
      let pro = {};
      pro.id = Number($(this).attr("data-variant"));
      pro.quantity = 1;
      pro.properties = {};
      pro.properties["_productType"] = "membership";
      pro.properties["_date_subscribe"] = new Date().valueOf();
      membershipProduct(pro);
    });
  // });
}

// great-choice popup
if(document.body.classList.contains("temp_membership")){

  // copy to clipboard
  let memberCopyBtns = document.querySelectorAll("[data-member-copy-btn]");
  memberCopyBtns.forEach(btn => {
    btn.addEventListener("click",function(e){
      e.preventDefault();
      // console.log("clicked",this.closest("[data-member-copy-wrap]").querySelector(".copy-text").innerHTML);
      let copyText = this.closest("[data-member-copy-wrap]").querySelector(".copy-text").innerHTML;
      navigator.clipboard.writeText(copyText);

      this.closest("[data-member-copy-wrap]").querySelector(".copied").style.opacity = 1;
      setTimeout(() => {
        this.closest("[data-member-copy-wrap]").querySelector(".copied").style.opacity = 0;
      },1000);
    });
  });

  // get dynamic member CODE
  let withMembership = document.querySelector(".membership-product-main.has-membership") || null;
  if(withMembership){
    var customerId = $('body').data('customer');
    var email = $('body').data('customer-email');
    $.ajax({
      url: baseUrlBsc + '/membership/getCustomerCoupons?customerId='+customerId+'&email='+encodeURIComponent(email),
      async: true,
      type: 'GET',
      contentType: "application/json",
      dataType: "json",
      headers: requestToken,
      success: function(data) {
      console.log("data",data);
      var memCodes = data.codes;
      // console.log("memCodes",memCodes);
      if(memCodes.length > 0 && document.querySelector("[data-dynamic-membership-code]")){
        document.querySelector("[data-dynamic-membership-code]").innerHTML = memCodes[0];
      }

      let monArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      let allowRenewAlert = document.querySelector(".membership-product-main.renew-alert-allow") || null;
      if(allowRenewAlert){
        if(data.isRenewed == false){
          // console.log("allowRenewAlert",allowRenewAlert);
          allowRenewAlert.classList.add("renew-alert");
        }else{
          let date = new Date(data.membershipEndDate);
          let day = date.getDate();
          let mon = monArr[date.getMonth()];
          let year = date.getFullYear();
          document.querySelector(".membership-product-main .expires").innerHTML = `Member till ${day} ${mon}, ${year}`;
        }
      }
      let memStartDate = document.querySelector("[data-mem-start-date]") || null;
      if(memStartDate && data.couponStartDate){
        let date = new Date(data.couponStartDate);
        let day = date.getDate();
        let mon = monArr[date.getMonth()];
        let year = date.getFullYear();
        memStartDate.innerHTML = `${day} ${mon}, ${year}`;
      }
      document.querySelector(".membership-product-main").classList.remove("renew-alert-allow");
    },
      error: function(err) {}
    });
  }
  
}
function membershipProduct(proObj) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { "Accept": "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(proObj)
  })
  .then(response => response.json()).then(response => {
    // console.log("response",response);
    let membershipBtns = document.querySelectorAll("[data-membership-a2c-btn]");
    if(membershipBtns.length){
      membershipBtns.forEach(btn => {
        btn.classList.add("disabled");
      });
    }
    
    // for header cart dot
    let cartDots = document.querySelectorAll('.Header__CartDot');
    cartDots.forEach(item => {
      item.classList.add('is-visible');
    });
    document.body.classList.add("great-choice");

    //for update cart data
    if(document.body.classList.contains("template-cart")){
      fetch('/cart').then(res => res.text()).then(res =>{
        if(document.querySelector(".section-cart-template")){
          var doc = new DOMParser().parseFromString(res, "text/html");
          document.querySelector(".section-cart-template").innerHTML = doc.querySelector(".section-cart-template").innerHTML;
          document.querySelector(".Cart__Checkout:not(.dont-remove-disabled)").classList.remove("disabled");
          document.body.classList.remove("cart-membership-popup-open");
        }
      });
    }
    updateCustomerCartId();
    
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally((e) => {
    // console.log("finally");
  });
}

// add attr to cart for CURRENT DATE
if(document.body.classList.contains("template-cart")){
  let cartMain = document.querySelector(".cart-page-inner.remove-membership-pro") || null;
  if(cartMain){
    let variant = cartMain.dataset.membershipVariant;
    let up = {};
    up[variant] = 0;
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: { updates : up },
      dataType: "json",
      success: function(data) {
        // console.log("data",data);
        location.href = "/cart";
      },
      error: function(error) {}
    });
  }else{
    // add date in CART ATTR
    // $.ajax({ url: '/cart/update.js', type: 'POST', data: { attributes: { '_date': new Date().toISOString().slice(0, 10) } }, dataType: "json", success: function(data) { }, error: function(error) { } });
  }

  function manageMembershipPopup(){
    // console.log("manageMembershipPopup");
    // cart membetshop POPUP
    let membershipPopups = document.querySelectorAll("[data-cart-membership-view-details]");
    if(membershipPopups.length > 0){
      membershipPopups.forEach(btn => {
        btn.addEventListener("click",function(e){
          e.preventDefault();
          // console.log("clicked",e);
          document.body.classList.add("cart-membership-popup-open");
        });
      });
  
      getMembershipPopupHTML();
    }
  
    // popup close btn click event
    let memPopupClose = document.querySelector("[data-cart-membership-popup] [data-cart-membership-popup-close]") || null;
    if(memPopupClose){
      memPopupClose.addEventListener("click",function(e){
        e.preventDefault();
        document.body.classList.remove("cart-membership-popup-open");
      });
    }
    
  
    function getMembershipPopupHTML(){
      // get MEMBERSHIP PAGE HTML
      let membershipPopup = document.querySelector("[data-cart-membership-view-details]") || null;
      if(!membershipPopup) return;
      fetch(`${membershipPopup.dataset.url}`)
      .then(response => response.text())
      .then(response => {
        let parser = new DOMParser();
        let newHTML = parser.parseFromString(response, 'text/html');
        // console.log("response",newHTML.querySelector(".product-membership"));
        document.querySelector("[data-cart-membership-popup-main]").innerHTML = newHTML.querySelector(".product-membership").outerHTML;
        console.log("greats choice>>>>>>",document.querySelector("[data-great-choice-popup-main]"));
        document.querySelector("[data-great-choice-popup-main] .selected-items-wrapper").innerHTML = newHTML.querySelector("[data-great-choice-popup-main] .selected-items-wrapper").innerHTML;
        // initGreatChoiceForMEMBERSHIP();
      });
    }
  }
  manageMembershipPopup();
  
}
/*
=================================================
Membership page - MEMBERSHIP ======> END
=================================================
*/


/*
=================================================
Order page - JUDGE.ME review ======> start
=================================================
*/
// if(document.body.classList.contains("template-order")){
let reviewPopup = document.querySelector("[data-review-popup]");
if(document.body.classList.contains("template-order") && reviewPopup){

  // review popup open click btn
  let openPopups = document.querySelectorAll("[data-review-popup-open-btn]");
  if(openPopups.length > 0){
    openPopups.forEach(btn => {
      btn.addEventListener("click",function(e){
        e.preventDefault();
        document.body.classList.add("open-review-popup");
        reviewPopup.querySelector("[data-review-product-id]").value = btn.dataset.productId;
      });
    });
  }

  // review popup close click btn
  let closePopups = document.querySelectorAll("[data-review-popup-close],[data-review-popup-overlay]");
  if(closePopups.length > 0){
    closePopups.forEach(btn => {
      btn.addEventListener("click",function(e){
        e.preventDefault();
        document.body.classList.remove("open-review-popup");
        reviewPopup.classList.remove("review-posted");
      });
    });
  }
  
  //form submit
  let form = reviewPopup.querySelector("form.review-form");
  if(form){

    // star radio change
    let stars = form.querySelectorAll(`input[name="rating"]`);
    if(stars.length > 0){
      stars.forEach(star => {
        star.addEventListener("change",function(e){
          //remove class: filled
          stars.forEach(starEle => {
            starEle.closest("label").classList.remove("filled");
          });
          let index = parseInt(this.dataset.index);
          // console.log("index",index);
          stars.forEach(starEle => {
            if(parseInt(starEle.dataset.index) <= index){
              starEle.closest("label").classList.add("filled");
            }
          });
        });
      });
    }

    // // textarea maxlength 300
    // let textarea = form.querySelector(`textarea`);
    // if(textarea){
    //   textarea.addEventListener("keydown",function(e){
    //     if(e.keyCode != 8){
    //       let val = this.value;
    //       // console.log("this.val",e);
    //       let len = val.split(" ").length;
    //       if(len > 300){
    //         e.preventDefault();
    //       }
    //     }
    //   });
    // }
    
    form.addEventListener("submit",function(e){
      e.preventDefault();
      // console.log("submit",$("[data-review-popup] form.review-form").serialize());
      let data = $("[data-review-popup] form.review-form").serialize();
      $.ajax({
        type: 'POST',
        url: "https://judge.me/api/v1/reviews",
        data: data,
        dataType: "text",
        success: function(resultData) { 
          // console.log("resultData",resultData);
          form.reset();
          reviewPopup.classList.add("review-posted");
          
          let stars = form.querySelectorAll(`input[name="rating"]`);
          //remove class: filled
          stars.forEach(starEle => {
            starEle.closest("label").classList.remove("filled");
          });
        },
        error:function(e) { console.log("eeeee",e); }
      });
      
    });
  }
}
// }
/*
=================================================
Order page - JUDGE.ME review ======> end
=================================================
*/

/*
=================================================
Product page - GALLERY SLIDER ======> start
=================================================
*/
if(document.body.clientWidth <= 1007 && document.querySelector(".Product__Slideshow")){
  // var flkty1 = $('.Product__Slideshow').flickity({
  //     wrapAround: true,
  //     pageDots: true,
  //     adaptiveHeight: true,
  //     // initialIndex: 0,
  //     cellAlign: "left",
  //     prevNextButtons: false,
  //     imagesLoaded: true,
  //     // accessibility: true, //true by default
  //     autoPlay: false, // advance cells every 3 seconds
  //     // on: {
  //     //   change: function() {
  //     //     console.log('Flickity change');
  //     //   }
  //     // }
  // });
  // console.log("flkty",flkty1);
  
  var swiper = new Swiper(".Product__Slideshow", {
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    loop: true,
    // pagination: {
    //   el: ".pdp-swiper-pagination",
    // }, 
    on: {
      slideChange: function () {
        console.log('Slide changed to:', this,this.realIndex);
        dataLayer.push({
          event: "image_swiper",
          page_type: document.body.dataset.page,
          product_name: this.el.closest(`.Product__Wrapper`).querySelector(".Product__InfoWrapper .ProductMeta__Title").innerHTML,
          // cta_text: "",
          // link_path: location.href,
          user_type_event: loggedin,
          User_ID_event: user_id,
          PC1: pc1,
          PC2: pc2,
        });
      }
    }
  });
}
/*
=================================================
Product page - GALLERY SLIDER ======> end
=================================================
*/


/*
=================================================
Product page - ACCORDIONS ======> start
=================================================
*/

// $(document).on("click","[data-pro-accordion-item] .pro-accordion-title",function(e){
//   e.preventDefault();
//   // console.log("sib",$(this).parents("[data-pro-accordion-item]").siblings());
//   $(this).parents("[data-pro-accordion-item]").toggleClass("active");
//   $(this).parents("[data-pro-accordion-item]").find(".pro-accordion-content").slideToggle();
// });
/*
=================================================
Product page - ACCORDIONS ======> end
=================================================
*/


$(document).on("click","[data-coll-video-action-btn]",function(e){
  e.preventDefault();
  if($(this).attr("data-action") == "pause"){
    $(".collInfo").removeClass("playing");
    document.querySelector("[data-collection-video]").pause();
  }else{
    $(".collInfo").addClass("playing");
    document.querySelector("[data-collection-video]").play();
  }
});






/*
=================================================
TILAK VERMA page - ======> start
=================================================
*/
var elemArr = document.querySelectorAll('.custom-image-slider_flic') || null;
elemArr.forEach((elem,index) => {
  if(index == 1){
    Flickity.Player.prototype.tick = function() {
      // do not tick if not playing
      if ( this.state != 'playing' ) {
        return;
      }
    
      var time = this.parent.options.autoPlay;
      // default to 3 seconds
      time = typeof time == 'number' ? time : 3000;
      var _this = this;
      // HACK: reset ticks if stopped and started within interval
      this.clear();
      this.timeout = setTimeout( function() {
        if(_this.parent.element.classList.contains("slider_ltor")){
          _this.parent.previous( true );
          _this.tick();
        }else{
          _this.parent.next( true );
          _this.tick();
        }
      }, time );
    };
  }
  var flkty = new Flickity( elem, {
  // options
  cellAlign: 'center',
  contain: true,
  wrapAround: true,
  autoPlay: true,
  pageDots: false,
  prevNextButtons: false,
  // draggable: false,
  pauseAutoPlayOnHover: false
  });
});


var elem2 = document.querySelector('.featured-looks-slider') || null;
if(elem2){
  var flkty = new Flickity( elem2, {
  // options
  cellAlign: 'left',
  contain: true, 
  pageDots: false,
  prevNextButtons: false, 
  autoPlay: 3000, // 2000ms = 2 seconds
  wrapAround: true, // Infinite loop
  pauseAutoPlayOnHover: false // Keeps autoplay even when hovered
  });
}
/*
=================================================
TILAK VERMA page - ======> end
=================================================
*/

/*
=================================================
Travelling Stylist page - ======> start
=================================================
*/
// BOOK A STYLIST
if(document.body.classList.contains("temp_travelling-stylist")){
var tsBookStylistArr = document.querySelectorAll('[data-ts-book-stylist]');
tsBookStylistArr.forEach(tsBookStylist => {
  tsBookStylist.addEventListener("click",function(e){
    e.preventDefault();
    if(document.body.classList.contains("logged")){
      document.body.classList.add("ts-popup");
    }else{
      document.body.classList.add("ts-popup-open-login");
    }
  });
});

// TS- popup close
var tspopupCloseArr = document.querySelectorAll('[data-ts-popup-close]');
tspopupCloseArr.forEach(close => {
  close.addEventListener("click",function(e){
    e.preventDefault();
    document.body.classList.remove("ts-popup","ts-popup-open-login");
  });
});


// PINCODE input keyup
$("[data-pincode-form-input]").keyup(function (event) {
  // console.log("event.which",event.key);
  var searchValue = $(this).val();
  searchValue = searchValue.replaceAll(",","");
  $(this).val(searchValue.replaceAll(".",""));
  
  if(event.which == 229){
    event.preventDefault();
    return false;
  }
  if(searchValue.length == 6){
    document.querySelector("[data-pincode-form-submit]").removeAttribute("disabled");
    return true;
  }else{
    document.querySelector("[data-pincode-form-submit]").setAttribute("disabled","disabled");
    document.body.classList.remove("ts-appointment");
    $(".ts-pincode-err").removeClass("active");
    $(".ts-popup-store-main").addClass("hide");
  }
  if(searchValue.length == 6 && event.which == 13){
    let thisInput = $(this)[0];
    document.querySelector("[data-pincode-form-submit]").click();
  }
});

$(`.ts-popup-store-main .view_all,.ts-popup-store-main .Grid__Cell a`).click(function(e){
  $("[data-pincode-form-input]").val('');
  document.querySelector("[data-pincode-form-submit]").setAttribute("disabled","disabled");
});
var inputPincodeTS = document.querySelector("[data-pincode-form-input]");
if(inputPincodeTS){
  // console.log("inputPincodeTS",inputPincodeTS,inputPincodeTS.value);
  inputPincodeTS.value = '';
  inputPincodeTS.onkeydown = function(e) {
    // console.log("key",e.which,e.key);
    var searchValue = $(this).val();
    if((e.which != 8 && searchValue.length == 6 && e.key.length == 1) || e.which == 32){
      return false;
    }
    // console.log("e",e);
    if(e.key.length == 1 && e.key.charCodeAt() >= 65 && e.key.charCodeAt() <= 122){
      // console.log("inside");
      e.preventDefault();
    }
  };
}

// date click event
$(document).on("click",".ts-appointment-data .ts-dates-item",function(e){
  e.preventDefault();
  // $(this).siblings().removeClass("active");
  $(this).addClass("active").siblings().removeClass("active");
  $(`.ts-appointment-time-main .ts-appointment-time-item[data-date="${$(this).attr("data-date")}"]`).addClass("active").siblings().removeClass("active");
  if(getUrlParameter("editCustomisations")){
    document.querySelectorAll(".ts-appointment-dates .ts-dates-item").forEach((item,index) => {
      if(item.classList.contains("active") && index > 5){
        document.querySelector(".ts-appointment-dates").scrollTo(500,0);
      }
    });
  }
});

// time slot click event
$(document).on("click",".ts-appointment-time .ts-appointment-time-slot",function(e){
  e.preventDefault();
  // $(this).siblings().removeClass("active");
  $(this).addClass("active").siblings().removeClass("active");
});

let bookAppoBtn = document.querySelector(`[data-ts-appointment-add-btn]`) || null;
if(bookAppoBtn){
  bookAppoBtn.addEventListener("click",function(e){
    e.preventDefault();
    const myHeaders1 = new Headers();
    myHeaders1.append("accept", "application/json, text/plain, */*");
    myHeaders1.append("accept-language", "en-GB,en-US;q=0.9,en;q=0.8");
    myHeaders1.append("content-type", "application/json");
    myHeaders1.append("metadata", `${customerMetaKey}`);
    myHeaders1.append("requesttoken", `${requestToken.requestToken}`);

    
    const raw1 = JSON.stringify({
      "shopifyCustomerId": `${document.body.dataset.customer}`,
      "pincode": parseInt(document.querySelector("[data-pincode-form-input]").value),
      "timeSlot": document.querySelector(".ts-appointment-time-item.active .ts-appointment-time-slot.active").dataset.slot,
      "appointmentDate": `${document.querySelector(".ts-appointment-time-item.active").dataset.date}`
    });
    const requestOptions1 = {
      method: "POST",
      headers: myHeaders1,
      body: raw1,
      redirect: "follow"
    };
    console.log("requestOptions1",requestOptions1);

  // fetch(`${baseUrlBsc}/home-visit/appointment/shopify/draft/save`, requestOptions1)
  //   .then((response) => response.text())
  //   .then((result) => {
  //     console.log("result",result);
  //     if(document.querySelector(`[data-ts-popup-main] .ts-popup-head-text`)) document.querySelector(`[data-ts-popup-main] .ts-popup-head-text`).innerHTML = `Request Received`;
  //     document.body.classList.remove("ts-appointment");
  //     document.body.classList.add("ts-appo-added");
  //     // $("[data-pincode-form-input]").val('');
  //     if(document.querySelector(`[data-pincode-form-input]`)) document.querySelector(`[data-pincode-form-input]`).value = "";
  //     document.querySelector("[data-pincode-form-submit]").setAttribute("disabled","disabled");
  //   })
  //   .catch((error) => console.error(error));
    // fetch(`${baseUrlBsc}/home-visit/appointment/shopify/draft/save`, requestOptions)
    // .then((response) => response.json())
    // .then((result) => {
    //   console.log("result",result);
    // })
    // .catch((error) => console.error(error));
    
    // let pro = {};
    // pro.id = Number(this.dataset.id);
    // pro.quantity = 1;
    // pro.properties = {};
    // pro.properties["pincode"] = document.querySelector("[data-pincode-form-input]").value;
    // let appoDate = document.querySelector(".ts-appointment-time-item.active").dataset.date;
    // pro.properties["appointmentDate"] = `${appoDate}`;
    // pro.properties["appointmentSlot"] = document.querySelector(".ts-appointment-time-item.active .ts-appointment-time-slot.active").dataset.slot;
    // pro.properties["_timestamp"] = Date.now().toString();

    // console.log("pro",pro);
    
    // fetch('/cart/update.js', {
    // method: 'POST',
    // headers: {
    // "Content-Type": "application/json",
    // },
    // body: JSON.stringify({ 
    //     updates: {
    //       "45780727857315":0
    //     }
    //   })
    // })
    // .then(response => {
    // return response.json();
    // })
    // .then(response => {
    // // console.log("response",response);
    //   fetch('/cart/add.js', {
    //     method: 'POST',
    //     headers: { "Accept": "application/json", "Content-Type": "application/json" },
    //     body: JSON.stringify(pro)
    //   })
    //   .then(response => response.json()).then(response => {
    //     console.log("response",response);
    //     if(getUrlParameter("editCustomisations")){
    //       location.href = '/cart';
    //     }else{
    //       document.body.classList.remove("ts-appointment");
    //       document.body.classList.add("ts-appo-added");
    //     }
    //     $("[data-pincode-form-input]").val('');
    //     document.querySelector("[data-pincode-form-submit]").setAttribute("disabled","disabled");
    //     updateCustomerCartId();
    //   })
    //   .catch((error) => {
    //     console.error('Error:', error);
    //   })
    //   .finally((e) => {
    //     // console.log("finally");
    //   });
    // })
    // .catch((error) => {
    // console.error('Error:', error);
    // });
  });
}

// cross button click event
var pincodeCross = document.querySelector("[data-pincode-cross-button]") || null;
if(pincodeCross){
  pincodeCross.addEventListener("click",function(e){
    e.preventDefault();
    document.querySelector("[data-pincode-form-input]").value = "";
    document.querySelector("[data-pincode-form-submit]").setAttribute("disabled","disabled");
    $(".ts-pincode-err").removeClass("active");
    $(".ts-popup-store-main").addClass("hide");
    document.body.classList.remove("ts-appointment");
    localStorage.customerPincode = "";
    document.querySelector(`.ts-appointment-dates-main .ts-dates-item.active`)?.classList.add("dummy-data");
  });
}

  
// submit btn click event
const daysArr = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
var pincodeSubmit = document.querySelector("[data-pincode-form-submit]") || null;
if(pincodeSubmit){
  pincodeSubmit.addEventListener("click",function(e){
    e.preventDefault();
    // console.log("submit clicked");
    this.setAttribute("disabled","disabled");
    setTimeout(() => {
      this.removeAttribute("disabled");
    },2000);

    localStorage.customerPincode = document.querySelector(`[data-pincode-form-input]`).value;
    manageHomeVisitForCD(document.querySelector(`[data-pincode-form-input]`).value);

    document.body.classList.remove("ts-appointment");
    // document.querySelector(".ts-appointment-dates").innerHTML = "";
    // document.querySelector(".ts-appointment-time").innerHTML = "";
    document.querySelector(`.ts-appointment-dates-main .ts-dates-item.active`)?.classList.add("dummy-data");

    $('.ts-popup-store-main').addClass("hide");
    $('.ts-pincode-err').removeClass("active");
    $('.ts-pincode-err-a').attr("href",`${$('.ts-pincode-err-a').attr("data-href")}?pinval=${document.querySelector(`[data-pincode-form-input]`).value}`);
    $('.ts-popup-store-text .view_all').attr("href",`${$('.ts-pincode-err-a').attr("data-href")}?pinval=${document.querySelector(`[data-pincode-form-input]`).value}`);

    if(Number(document.querySelector("[data-ts-popup-login]").dataset.customerOrders) > -1){
    var _7dayTimestamp = 604800000; // 1000*60*60*24*7
    var timestamp = Date.now();
    _7dayTimestamp += timestamp;

    let today = new Date();
    // if(today.getHours() >= 14){
    //   today = new Date(Date.now()+86400000);
    // }
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    let yyyy = today.getFullYear();    
    let currDate = `${yyyy}-${mm}-${dd}`;
    console.log("currDate",currDate);

    let today7 = new Date(_7dayTimestamp);
    let dd7 = String(today7.getDate()).padStart(2, '0');
    let mm7 = String(today7.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    let yyyy7 = today7.getFullYear();    
    let dateAfter7 = `${yyyy7}-${mm7}-${dd7}`;
    console.log("dateAfter7",dateAfter7);
    const myHeaders = new Headers();
    myHeaders.append("accept", "application/json, text/plain, */*");
    myHeaders.append("Host", `${baseUrlBsc}`);
    myHeaders.append("requesttoken", requestToken.requestToken);
    
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
    let timeSlots;
    fetch(`${baseUrlBsc}/home-visit/booked-slots?pincode=${document.querySelector("[data-pincode-form-input]").value}&from=${currDate}&to=${dateAfter7}&isSizingAvailable=${Number(document.querySelector("[data-ts-popup-login]").dataset.customerOrders) > 0 ? true : false}&customerId=IN-${document.body.dataset.customer}`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      console.log("result",result);
      if(result.success == true){


        document.querySelector(".ts-appointment-dates").innerHTML = "";
        document.querySelector(".ts-appointment-time").innerHTML = "";

        if(Number(document.querySelector("[data-ts-popup-login]").dataset.customerOrders) > 0){
        let currTimeStamp = Date.now();
        let day,date,mon,year,fDate;
        let dateHTML = '';
        let activeClass = ' active';
        for(let i = 0; i <= 6; i++){
          // console.log("i",i);
          let dateTimestamp = 1000*60*60*24*i;
          if(i == 0){
            // console.log("date 0",new Date(),"day",daysArr[new Date().getDay()],"date",String(new Date().getDate()).padStart(2, '0'));
            if(new Date().getHours() >= 14){
              day = daysArr[new Date(Date.now()+86400000).getDay()];
              date = String(new Date(Date.now()+86400000).getDate()).padStart(2, '0');
              mon = String(new Date(Date.now()+86400000).getMonth() + 1).padStart(2, '0');
              year = new Date(Date.now()+86400000).getFullYear();
              currTimeStamp = Date.now()+86400000;
            }else{
              day = daysArr[new Date().getDay()];
              date = String(new Date().getDate()).padStart(2, '0');
              mon = String(new Date().getMonth() + 1).padStart(2, '0');
              year = new Date().getFullYear();
            }
          }else{
            dateTimestamp+=currTimeStamp;
            // console.log("date",new Date(dateTimestamp),"day",daysArr[new Date(dateTimestamp).getDay()],"date",String(new Date(dateTimestamp).getDate()).padStart(2, '0'));
            day = daysArr[new Date(dateTimestamp).getDay()];
            date = String(new Date(dateTimestamp).getDate()).padStart(2, '0');
            mon = String(new Date(dateTimestamp).getMonth() + 1).padStart(2, '0');
            year = new Date(dateTimestamp).getFullYear();
          }
          fDate = `${year}-${mon}-${date}`;
          // console.log("day",day,"date",date,"fDate",fDate);
          dateHTML += `<div class="ts-dates-item${activeClass}" data-date="${fDate}"><span class="ts-day">${day}</span><span class="ts-date">${date}</span></div>`;

          timeSlots = `<div class="ts-appointment-time-item${activeClass}" data-date="${fDate}">`;
          let bookedSlotsList = [];
          if(result.content.bookedSlots.length > 0){
            result.content.bookedSlots.forEach(bookSlot => {
              if(bookSlot.date == fDate){
                bookedSlotsList = bookSlot.bookedTimeSlotList;
              }
            });
          }
          let slotActive = 0;
          // let currTime = new Date().getHours();
          result.content.slots.forEach(slot => {
            let dClass = '';
            if(bookedSlotsList.includes(slot)){
              dClass = ' disabled';
            }
            // if(i == 0 && currTime >= 14){
            //   dClass = ' disabled';
            // }
            if(dClass == "" && slotActive == 0){
              timeSlots += `<div class="ts-appointment-time-slot${dClass} active" data-slot="${slot}">${slot}</div>`;
              slotActive++;
            }else{
              timeSlots += `<div class="ts-appointment-time-slot${dClass}" data-slot="${slot}">${slot}</div>`;
            }
          });
          timeSlots += `</div>`;
          // console.log("timeSlots",timeSlots);
          document.querySelector(".ts-appointment-time").innerHTML += timeSlots;
          if(i == 0) activeClass = '';
        }
        document.querySelector(".ts-appointment-dates").innerHTML = dateHTML;
        document.body.classList.add("ts-appointment");
        if(getUrlParameter("editCustomisations")){
          document.querySelector(`.ts-appointment-dates-main .ts-dates-item[data-date="${getUrlParameter("date")}"]`).click();
          // setTimeout(() => {
            document.querySelector(`.ts-appointment-time-main .ts-appointment-time-item.active .ts-appointment-time-slot[data-slot="${getUrlParameter("slot")}"]`).click();
          // },0);
        }

      // orders 0
      }else{
        storeFinding(document.querySelector("[data-pincode-form-input]").value,true);
      }
        
      // else
      }else{
        storeFinding(document.querySelector("[data-pincode-form-input]").value);
      }
    })
    .catch((error) => console.error(error));

  }else{
    // 0 orders
    storeFinding(document.querySelector("[data-pincode-form-input]").value);
  }
  });
}



// var elem3 = document.querySelector('.ts-testimonial_slider') || null;
// if(elem3){
//   var flkty = new Flickity( elem3, {
//   // options
//   cellAlign: 'left',
//   contain: true, 
//   pageDots: true,
//   prevNextButtons: false
//   });
// }

function storeFinding(pincode,serviceAvail = false){
  geocoder = new google.maps.Geocoder();
  // console.log("clicked");
  geocoder.geocode({ 'address': pincode }, function (results, status) {
    // console.log(results,"status",status,"serviceAvail",serviceAvail);
    $('.ts-pincode-err').removeClass("active");
    if(results != null && results.length > 0){
      dispaly_storesTS(results[0],serviceAvail);
    }else{
      noStoreFound_forPincodeBlockTS();
    }
  });
}
var store_slider = '';
function dispaly_storesTS(place, serviceAvail, userLatitude = "", userLongitude = "") {
  // console.log("dispaly_stores");
  var current_pincode;
  var country;
  var state;
  var city;

  if (userLatitude == "") {
    var userLatitude = place.geometry.location.lat();
    var userLongitude = place.geometry.location.lng();
  }
  
  var maxDistance = 50;
  const nearbyStores = findNearbyStoresTS(userLatitude,userLongitude,maxDistance);

  // console.log("nearbyStores>>>>>>>",nearbyStores);
  if(nearbyStores.length > 0){
    $(".ts-popup-store-main .Grid__Cell").addClass("hide");
    localStorage.customerNearestStore = `Nearest store: ${document.querySelector(`.ts-popup-store-main .Grid__Cell[data-place-id="${nearbyStores[0].place_id}"]`).dataset.storeTitle}`;    
  }else{
    localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
    $('.ts-pincode-err.pincode-err-text').addClass("active");
  }
  let lastIndex = false;
  // console.log("nearbyStores",nearbyStores);
  nearbyStores.forEach((place, index) => {
    // console.log("index",index);
    if(index == (nearbyStores.length - 1)){
      lastIndex = true;
    }
    var getPlaceID = place.place_id;
    $('.ts-popup-store-list .Grid__Cell[data-place-id="' + getPlaceID + '"]').removeClass("hide");
  });
  if(lastIndex){
    // console.log("lastIndex",lastIndex);
    $('.ts-popup-store-main').removeClass("hide");
    if(serviceAvail == false){
      $('.ts-pincode-err.pincode-err-text').addClass("active");
    }else{
      $('.ts-pincode-err.pincode-err-need-sizing').addClass("active");
    }
    if(typeof store_slider == 'object'){
      store_slider.destroy();
      store_slider = '';
    }
    if($('.ts-popup-store-list .ts-store-list').length > 0){
      store_slider = new Flickity('.ts-popup-store-list .ts-store-list',{
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        wrapAround: false,
        prevNextButtons: true,
        dragThreshold: 8,
        groupCells: true, 
        contain: true
      });
      $('.ts-popup-store-main .ts-popup-store-count').html($('.ts-popup-store-main .Grid__Cell:not(.hide)').length);
    }
  }
}

function findNearbyStoresTS(userLatitude, userLongitude, maxDistance) {
  // console.log("findNearbyStores",userLatitude,userLongitude,maxDistance);
  const nearbyStores = [];
  $(".ts-popup-store-main .Grid__Cell").each(function () {
    const storeLatitude = parseFloat($(this).attr("latitude"));
    const storeLongitude = parseFloat($(this).attr("longitude"));
    var place_id = $(this).attr("data-place-id");
    const distance = calculateDistance(userLatitude,userLongitude,storeLatitude,storeLongitude);
    if (distance <= maxDistance) {
      nearbyStores.push({place_id: place_id,distance: distance,});
    }
  });
  // console.log("findNearbyStores", nearbyStores);
  nearbyStores.sort(function (a, b) {
    return a.distance - b.distance;
  });
  // console.log("sorted", nearbyStores);
  return nearbyStores;
}

function noStoreFound_forPincodeBlockTS() {
  // console.log("noStoreFound_forPincodeBlockTS>>>>>>");
  $('.ts-popup-store-main').addClass("hide");
  $('.ts-pincode-err.pincode-err-text').addClass("active");
  localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
}

// when come from CART for EDIT
if(getUrlParameter("editCustomisations")){
  // document.querySelector("[data-ts-book-stylist]").click();
  document.querySelector("[data-ts-appointment-add-btn]").innerHTML = 'Save changes';
  document.body.classList.add("ts-popup");
  document.querySelector("[data-pincode-form-input]").value = getUrlParameter("pincode");
  document.querySelector("[data-pincode-form-submit]").removeAttribute("disabled");
  document.querySelector("[data-pincode-form-submit]").click();
}
}
/*
=================================================
Travelling Stylist page - ======> end
=================================================
*/


/*
=================================================
My appointments page - ======> start
=================================================
*/
if(document.body.classList.contains("temp_my-appointments") || document.body.dataset.customer != null){
  function getCustomerAppointments(){
    // console.log("getCustomerAppointments");
    const myHeadersA = new Headers();
    myHeadersA.append("accept", "application/json, text/plain, */*");
    myHeadersA.append("Content-Type", "application/json");
    myHeadersA.append("Host", `${baseUrlBsc}`);
    myHeadersA.append("requesttoken", requestToken.requestToken);
    myHeadersA.append("metadata", `${customerMetaKey}`);
    
    const requestOptionsA = {
      method: "POST",
      headers: myHeadersA,
      body: JSON.stringify({
        "customerIdentifier": `${document.body.dataset.customer}`
      }),
      redirect: "follow"
    };
    
    if(document.body.dataset.customer != ""){
    // fetch(`${baseUrlBsc}/home-visit/appointment/customerAppointments`, requestOptionsA)
    // .then((response) => response.json())
    // .then((result) => {
    //   // console.log("result",result);
    //   if(result.content != null){
    //     let appoHTML = ``;
    //     let appoMobileHTML = ``;
    //     result.content.forEach(appoinment => {
    //       appoHTML += `<div class="appointment_table_item">
    //             <div class="appointment_table_text">${appoinment.remoteOrderId}</div>
    //             <div class="appointment_table_text">${appoinment.appointmentDate}, ${appoinment.timeSlot}</div>
    //             <div class="appointment_table_text">${appoinment.address?.shippingAddress}</div>
    //             <div class="appointment_table_text ${appoinment.status.toLowerCase()}">${appoinment.status}</div>
    //             <div class="appointment_table_text">${appoinment.stylistName ? appoinment.stylistName : "-"}</div>
    //           </div>`;
    
    //       appoMobileHTML += `<div class="appointment_table_item">
    //             <div class="appointment_table_item_left">
    //               <div class="appointment_table_title">Appointment ID</div>
    //               <div class="appointment_table_title">Appt. Date &amp; Time</div>
    //               <div class="appointment_table_title">Appointment Status</div>
    //               <div class="appointment_table_title">Stylist Name</div>
    //               <div class="appointment_table_title">Address</div>
    //             </div>
    //             <div class="appointment_table_item_right">
    //               <div class="appointment_table_text">${appoinment.remoteOrderId}</div>
    //               <div class="appointment_table_text">${appoinment.appointmentDate}, ${appoinment.timeSlot}</div>
    //               <div class="appointment_table_text ${appoinment.status.toLowerCase()}">${appoinment.status}</div>
    //               <div class="appointment_table_text">${appoinment.stylistName ? appoinment.stylistName : "-"}</div>
    //               <div class="appointment_table_text">${appoinment.address?.shippingAddress}</div>
    //             </div>
    //           </div>`;
    //     });
    //     document.querySelector(".appointment_table.dk_show .appointment_table_wrp").innerHTML += appoHTML;
    //     document.querySelector(".appointment_table.mb_show .appointment_table_wrp").innerHTML = appoMobileHTML;
    //   }else{
    //     // console.log("else>>>>>>>>>>>>");
    //     var fetchURL = `${window.location.href}`;
    //     fetch(fetchURL,{
    //     method:'GET', headers: {
    //     'Content-Type': 'application/json'}
    //     })
    //     .then((response) =>{
    //     return response.text();
    //     }).then(data =>{
    //       let parser = new DOMParser();
    //       let parsedHtml = parser.parseFromString(data, 'text/html');
    //       customerMetaKey = parsedHtml.querySelector('body').getAttribute("data-customer-key");
    //       // console.log("parsedHtml",parsedHtml,"customerMetaKey",customerMetaKey);
    //       getCustomerAppointments();
    //     });
    //   }
    // })
    // .catch((error) => console.error(error));
    }
  }
  // customerMetaKey = '';
  // getCustomerAppointments();
}
/*
=================================================
My appointments page - ======> end
=================================================
*/

/*
=================================================
Home page Block - ======> Start
=================================================
*/
let home_popup = document.querySelector('.home-imgtext-content p[data-home-pop]');
if(home_popup){
home_popup.addEventListener("click", (pop_event) => {
  document.querySelector('.home-pop-imgtext-item').classList.add("home-popup_open");
  // setTimeout(() => {
  //   document.querySelector('.home-pop-imgtext-item').classList.remove("home-popup_open");  
  // },5000);
});
}
/*
=================================================
Home page Block - ======> end
=================================================
*/

/*
=================================================
Lead Gen - ======> Start
=================================================
*/
let leadgenOpenArr = document.querySelectorAll('[data-lead-gen-open]');
let leadgenCloseArr = document.querySelectorAll('[data-lead-gen-close]');
let leadgenStoreOpen = document.querySelectorAll('[data-store-popup]');
let leadgenStoreCloseArr = document.querySelectorAll('[data-lead-gen-popup-close]');
if(leadgenOpenArr.length > 0){
  leadgenOpenArr.forEach(open => {
    open.addEventListener("click", (e) => {
      console.log("clicked");
      e.preventDefault();
      document.querySelector('.leadgen_main_popup').classList.add("active");
    });
  });
  leadgenCloseArr.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      document.querySelector('.leadgen_main_popup').classList.remove("active");
    });
  });
}
// data-lead-gen-open-custom
$(document).on("click","[data-lead-gen-open-custom]",function(e){
  e.preventDefault();
  document.querySelector('[data-lead-gen-open]')?.click();
});

if(leadgenStoreOpen){
  leadgenStoreOpen.forEach(open => {
    open.addEventListener("click", (e) => {
      console.log("clicked");
      e.preventDefault();
      // document.querySelector('.leadgen_main_popup').classList.remove("active");
      document.querySelector('.leadgen_main_popup').classList.add("active");
      document.querySelector('.leadgen_main_popup').classList.add("StorePopupOpen");
    });
  });
  leadgenStoreCloseArr.forEach(closeBtn => {
    closeBtn.addEventListener("click", () => {
      document.querySelector('.leadgen_main_popup').classList.remove("active"); // new added
      document.querySelector('.leadgen_main_popup').classList.remove("StorePopupOpen");
      // document.querySelector('.ldg_store_popup').classList.remove("show-leadgen-details");
    });
  });
}

// input keyup
var inputPincodeLeadGen = document.querySelector("[data-ldg-pincode-form-input]");
if(inputPincodeLeadGen){
  inputPincodeLeadGen.value = '';
  inputPincodeLeadGen.onkeyup = function(e) {
    // console.log("this.value.length",this.value.length);
    if(this.value.length == 6){
      document.querySelector("[data-ldg-pincode-form-submit]").removeAttribute("disabled");
    }else{
      document.querySelector("[data-ldg-pincode-form-submit]").setAttribute("disabled","disabled");
      document.querySelector(".ldg-pincode-err")?.classList.remove("active");
      document.querySelector(".ldg-popup-store-main")?.classList.add("hide");
    }
  };
  inputPincodeLeadGen.onkeydown = function(e) {
    // console.log("key",e.which,e.key);
    if(e.key == "/" || e.key == "*" || e.key == "+" || e.key == "-" || e.key == "."){
      e.preventDefault();
      return false;
    }else{
      if((e.key >= 0 && e.key <= 9) && this.value.length == 6){
        e.preventDefault();
        return false;
      }else{
        if(e.which == 13){
          document.querySelector("[data-ldg-pincode-form-submit]").click();
        }
      }
    }
  };
}

// submit btn click event
var pincodeSubmit = document.querySelector("[data-ldg-pincode-form-submit]") || null;
if(pincodeSubmit){
  pincodeSubmit.addEventListener("click",function(e){
    e.preventDefault();
    console.log("submit clicked");
    document.querySelector(".ldg_store_popup")?.classList.add("show-leadgen-details");
    storeFindingLeadGen(document.querySelector("[data-ldg-pincode-form-input]").value);
    localStorage.customerPincode = document.querySelector("[data-ldg-pincode-form-input]").value;
    manageHomeVisitForCD(document.querySelector("[data-ldg-pincode-form-input]").value);
    setPincodeVariable();
  });
}

// cross button click event
var pincodeCrossLeadGen = document.querySelector("[data-ldg-pincode-cross-button]") || null;
if(pincodeCrossLeadGen){
  pincodeCrossLeadGen.addEventListener("click",function(e){
    e.preventDefault();
    document.querySelector("[data-ldg-pincode-form-input]").value = "";
    document.querySelector(".ldg-pincode-err")?.classList.remove("active");
    document.querySelector(".ldg-popup-store-main")?.classList.add("hide");
    document.querySelector(".ldg_store_popup")?.classList.remove("show-leadgen-details");
    document.querySelector("[data-ldg-pincode-form-submit]").setAttribute("disabled","disabled");
    localStorage.customerPincode = "";
    setPincodeVariable();
  });
}

function storeFindingLeadGen(pincode,serviceAvail = false){
  geocoder = new google.maps.Geocoder();
  // console.log("clicked");
  geocoder.geocode({ 'address': pincode }, function (results, status) {
    console.log(results,"status",status,"serviceAvail",serviceAvail);
    if(results != null && results.length > 0){
      dispaly_storesLeadGen(results[0],serviceAvail);
    }else{
      noStoreFound_forPincodeBlockLeadGen();
    }
  });
}
var store_sliderLG = '';
function dispaly_storesLeadGen(place, serviceAvail, userLatitude = "", userLongitude = "") {
  // console.log("dispaly_storesLeadGen>>>>");
  var current_pincode;
  var country;
  var state;
  var city;

  if (userLatitude == "") {
    var userLatitude = place.geometry.location.lat();
    var userLongitude = place.geometry.location.lng();
  }
  
  var maxDistance = 50;
  const nearbyStores = findNearbyStoresLeadGen(userLatitude,userLongitude,maxDistance);

  // console.log("nearbyStores>>>>>>>",nearbyStores);
  if(nearbyStores.length > 0){
    document.querySelectorAll(".ldg-popup-store-main .Grid__Cell").forEach(cell => {
      cell.classList.add("hide");
    });
    localStorage.customerNearestStore = `Nearest store: ${document.querySelector(`.ldg-popup-store-main .Grid__Cell[data-place-id="${nearbyStores[0].place_id}"]`).dataset.storeTitle}`;
  }else{
    document.querySelector(".ldg-pincode-err")?.classList.add("active");
    localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
  }
  let lastIndex = false;
  // console.log("nearbyStores",nearbyStores);
  
  nearbyStores.forEach((place, index) => {
    let storeHTML = "";
    // console.log("index",index);
    if(index == (nearbyStores.length - 1)){
      lastIndex = true;
    }
    var getPlaceID = place.place_id;
    document.querySelector('.ldg-popup-store-main .Grid__Cell[data-place-id="' + getPlaceID + '"]')?.classList.remove("hide");
    storeHTML = decodeHTML(document.querySelector('.ldg-popup-store-main .Grid__Cell[data-place-id="' + getPlaceID + '"]').outerHTML);
    document.querySelector('.ldg-popup-store-main .Grid__Cell[data-place-id="' + getPlaceID + '"]').remove();
    document.querySelector('.ldg-popup-store-main .Grid__Cell:last-child').outerHTML += storeHTML;
  });
  // console.log("storeHTML",storeHTML);
  if(lastIndex){
    // console.log("lastIndex",lastIndex);
    document.querySelector(".ldg-popup-store-main")?.classList.remove("hide");
    if(typeof store_sliderLG == 'object'){
      store_sliderLG.destroy();
      store_sliderLG = '';
    }
    if(document.querySelectorAll('.ldg-popup-store-list .lead-gen-store-list').length > 0){
      store_sliderLG = new Flickity('.ldg-popup-store-list .lead-gen-store-list',{
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        wrapAround: false,
        prevNextButtons: true,
        dragThreshold: 8,
        groupCells: true, 
        contain: true
      });
      document.querySelector('.ldg-popup-store-main .ldg-popup-store-count').innerHTML = document.querySelectorAll('.ldg-popup-store-main .Grid__Cell:not(.hide)').length;
      if(document.body.clientWidth <= 767){
        if(document.querySelector(".ldg_store_popup")) document.querySelector(".ldg_store_popup").scrollTo(0,1000);
      }
    }
  }
}

function findNearbyStoresLeadGen(userLatitude, userLongitude, maxDistance) {
  // console.log("findNearbyStores",userLatitude,userLongitude,maxDistance);
  const nearbyStores = [];
  $(".ldg-popup-store-main .Grid__Cell").each(function () {
    const storeLatitude = parseFloat($(this).attr("latitude"));
    const storeLongitude = parseFloat($(this).attr("longitude"));
    var place_id = $(this).attr("data-place-id");
    const distance = calculateDistance(userLatitude,userLongitude,storeLatitude,storeLongitude);
    if (distance <= maxDistance) {
      nearbyStores.push({place_id: place_id,distance: distance,});
    }
  });
  // console.log("findNearbyStores", nearbyStores);
  nearbyStores.sort(function (a, b) {
    return a.distance - b.distance;
  });
  // console.log("sorted", nearbyStores);
  return nearbyStores;
}

function noStoreFound_forPincodeBlockLeadGen() {
  // console.log("noStoreFound_forPincodeBlockLeadGen>>>>>>");
  document.querySelector('.ldg-popup-store-main')?.classList.add("hide");  
  document.querySelector('.ldg-pincode-err')?.classList.add("active");
  localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
}

/*
=================================================
Lead Gen - ======> end
=================================================
*/

/*
=================================================
Check Delivery - ======> start
=================================================
*/

// check delivery input keyup
var inputPincodeCD = document.querySelector("[data-cd-pincode-form-input]");
if(inputPincodeCD){
  inputPincodeCD.value = '';
  inputPincodeCD.onkeyup = function(e) {
    // console.log("this.value.length",this.value.length);
    if(this.value.length == 6){
      document.querySelector("[data-cd-pincode-form-submit]").removeAttribute("disabled");
    }else{
      document.querySelector("[data-cd-pincode-form-submit]").setAttribute("disabled","disabled");
      document.querySelector(".pro-check-delivery")?.classList.remove("show-cd-details");
      $(".cd-info-grid-item-info.cd-info-grid-item-info-hv a").addClass("hide");
    }
  };
  inputPincodeCD.onkeydown = function(e) {
    // console.log("key",e.which,e.key);
    if(e.key == "/" || e.key == "*" || e.key == "+" || e.key == "-" || e.key == "."){
      e.preventDefault();
      return false;
    }else{
      if((e.key >= 0 && e.key <= 9) && this.value.length == 6){
        e.preventDefault();
        return false;
      }else{
        if(e.which == 13){
          document.querySelector("[data-cd-pincode-form-submit]").click();
        }
      }
    }
  };
}

// submit btn click event
// const daysArr = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
var pincodeSubmit = document.querySelector("[data-cd-pincode-form-submit]") || null;
if(pincodeSubmit){
  pincodeSubmit.addEventListener("click",function(e){
    e.preventDefault();
    console.log("submit clicked");
    document.querySelector(".pro-check-delivery")?.classList.add("show-cd-details");
    storeFindingCD(document.querySelector("[data-cd-pincode-form-input]").value);
    manageHomeVisitForCD(document.querySelector("[data-cd-pincode-form-input]").value);
    getDeliveryCD(document.querySelector("[data-cd-pincode-form-input]").value);
  });
}

// cross button click event
var pincodeCrossCD = document.querySelector("[data-cd-pincode-cross-button]") || null;
if(pincodeCrossCD){
  pincodeCrossCD.addEventListener("click",function(e){
    e.preventDefault();
    document.querySelector("[data-cd-pincode-form-input]").value = "";
    document.querySelector(".pro-check-delivery")?.classList.remove("show-cd-details");
    $(".cd-info-grid-item-info.cd-info-grid-item-info-hv a").addClass("hide");
    document.querySelector("[data-cd-pincode-form-submit]").setAttribute("disabled","disabled");
    if(document.querySelector(`[data-cd-store-details]`)) document.querySelector(`[data-cd-store-details]`).innerHTML = `Nearest store`;
    localStorage.customerPincode = "";
    setPincodeVariable();
  });
}

function storeFindingCD(pincode,serviceAvail = false){
  localStorage.customerPincode = pincode;
  setPincodeVariable();
  geocoder = new google.maps.Geocoder();
  // console.log("clicked");
  geocoder.geocode({ 'address': pincode }, function (results, status) {
    console.log(results,"status",status,"serviceAvail",serviceAvail);
    if(results != null && results.length > 0){
      dispaly_storesCD(results[0],serviceAvail);
    }else{
      noStoreFound_forPincodeBlockCD();
    }
  });
}

function dispaly_storesCD(place, serviceAvail, userLatitude = "", userLongitude = "") {
  // console.log("dispaly_storesCD>>>>");
  var current_pincode;
  var country;
  var state;
  var city;
  if (userLatitude == "") {
    var userLatitude = place.geometry.location.lat();
    var userLongitude = place.geometry.location.lng();
  }  
  var maxDistance = 50;
  const nearbyStores = findNearbyStoresCD(userLatitude,userLongitude,maxDistance);
  // console.log("nearbyStores>>>>>>>",nearbyStores);
  if(nearbyStores.length > 0){
    if(document.querySelector(`[data-cd-store-details]`) && document.querySelector(`.cd-popup-store-list .Grid__Cell[data-place-id="${nearbyStores[0].place_id}"]`)){
      document.querySelector(`[data-cd-store-details]`).innerHTML = `Nearest store: ${document.querySelector(`.cd-popup-store-list .Grid__Cell[data-place-id="${nearbyStores[0].place_id}"]`).dataset.storeTitle}`;
      localStorage.customerNearestStore = `Nearest store: ${document.querySelector(`.cd-popup-store-list .Grid__Cell[data-place-id="${nearbyStores[0].place_id}"]`).dataset.storeTitle}`;
      document.querySelector(`.cd-info-grid-item-info-pincode a`).href = `/pages/stores?pinval=${document.querySelector("[data-cd-pincode-form-input]").value}`;
      document.querySelector(`.cd-info-grid-item-info-pincode a`).innerHTML = `VIEW DETAILS`;
      if(document.querySelector(`.cd-info-grid-item-info-hv a:not(.badge-coming-soon)`)) document.querySelector(`.cd-info-grid-item-info-hv a:not(.badge-coming-soon)`).href = `/pages/travelling-stylist?editCustomisations=true&pincode=${document.querySelector("[data-cd-pincode-form-input]").value}`;
      document.querySelector(`.pro-check-delivery`).classList.remove("no-stores");
    }
  }else{
    if(document.querySelector(`[data-cd-store-details]`)){
      document.querySelector(`[data-cd-store-details]`).innerHTML = `Uh-oh! No nearby stores found`;
      document.querySelector(`.cd-info-grid-item-info-pincode a`).innerHTML = `VIEW ALL STORES`;
      localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
      document.querySelector(`.pro-check-delivery`).classList.add("no-stores");
    }
  }
}

function findNearbyStoresCD(userLatitude, userLongitude, maxDistance) {
  // console.log("findNearbyStores",userLatitude,userLongitude,maxDistance);
  const nearbyStores = [];
  $(".cd-popup-store-list .Grid__Cell").each(function () {
    const storeLatitude = parseFloat($(this).attr("latitude"));
    const storeLongitude = parseFloat($(this).attr("longitude"));
    var place_id = $(this).attr("data-place-id");
    const distance = calculateDistance(userLatitude,userLongitude,storeLatitude,storeLongitude);
    if (distance <= maxDistance) {
      nearbyStores.push({place_id: place_id,distance: distance,});
    }
  });
  // console.log("findNearbyStores", nearbyStores);
  nearbyStores.sort(function (a, b) {
    return a.distance - b.distance;
  });
  // console.log("sorted", nearbyStores);
  return nearbyStores;
}

function noStoreFound_forPincodeBlockCD() {
  document.querySelector(`.pro-check-delivery`).classList.add("no-stores");
  // console.log("noStoreFound_forPincodeBlockCD>>>>>>");
  if(document.querySelector(`[data-cd-store-details]`)) document.querySelector(`[data-cd-store-details]`).innerHTML = `Uh-oh! No nearby stores found`;
  localStorage.customerNearestStore = `Uh-oh! No nearby stores found`;
}

function manageHomeVisitForCD(pincode){
  // console.log("manageHomeVisitForCD>>>>>>",pincode);
  var _7dayTimestamp = 604800000; // 1000*60*60*24*7
  var timestamp = Date.now();
  _7dayTimestamp += timestamp;

  let today = new Date();
  // if(today.getHours() >= 14){
  //   today = new Date(Date.now()+86400000);
  // }
  let dd = String(today.getDate()).padStart(2, '0');
  let mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  let yyyy = today.getFullYear();    
  let currDate = `${yyyy}-${mm}-${dd}`;
  // console.log("currDate",currDate);

  let today7 = new Date(_7dayTimestamp);
  let dd7 = String(today7.getDate()).padStart(2, '0');
  let mm7 = String(today7.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  let yyyy7 = today7.getFullYear();    
  let dateAfter7 = `${yyyy7}-${mm7}-${dd7}`;
  // console.log("dateAfter7",dateAfter7);
  const myHeaders = new Headers();
  myHeaders.append("accept", "application/json, text/plain, */*");
  myHeaders.append("Host", `${baseUrlBsc}`);
  myHeaders.append("requesttoken", requestToken.requestToken);
  
  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };
  
  fetch(`${baseUrlBsc}/home-visit/booked-slots?pincode=${pincode}&from=${currDate}&to=${dateAfter7}&isSizingAvailable=true&customerId=IN-${document.body.dataset.customer}`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    // console.log("result",result);
    if(result.success == true){
      localStorage.customerPincodeAvailHV = true;
      if(document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`)) document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`).classList.add("hide");
      if(document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`)) document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`).classList.remove("hide");
    }else{
      localStorage.customerPincodeAvailHV = false;
      if(document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`)) document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`).classList.add("hide");
      if(document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`)) document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`).classList.remove("hide");
    }
  })
  .catch((error) => console.error(error));
}


function getDeliveryCD(pincode){
  console.log("getDeliveryCD>>>>>>>>>>",pincode);
  if(document.querySelector(`.pro-check-delivery`)){
    let allowToGetDelivery = true;
    let proType = document.querySelector(`.pro-check-delivery`).dataset.productType;
    // if(document.body.classList.contains("template-product")){
    //   let deliveryObjByProTypes = localStorage.deliveryObjByProTypes;
    //   if(deliveryObjByProTypes != undefined){
    //     deliveryObjByProTypesOBJ = JSON.parse(deliveryObjByProTypes);
    //     let currTime = new Date().getTime();
    //     if(deliveryObjByProTypesOBJ[proType] != undefined && deliveryObjByProTypesOBJ[proType][`${pincode}`] != undefined && deliveryObjByProTypesOBJ[proType][`${pincode}`].time > currTime){
    //       allowToGetDelivery = false;
    //       if(document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`)) document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`).innerHTML = deliveryObjByProTypesOBJ[proType][pincode].message;
    //     }
    //   }
    // }
    // console.log("allowToGetDelivery",allowToGetDelivery);
    if(allowToGetDelivery){
      let monthsArr = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];
  
      const myHeaders = new Headers();
      myHeaders.append("accept", "application/json, text/plain, */*");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Host", `${baseUrlBsc}`);
      myHeaders.append("requesttoken", requestToken.requestToken);
      let bodyOBJ = [{
        "productId": `${productInfo.id}`,
        "category": getCreateMeasurementCategory(document.querySelector(`[data-product-fitsmart-attributes-ele]`).dataset.type),
        "productType": getCreateMeasurementCategory(document.querySelector(`[data-product-fitsmart-attributes-ele]`).dataset.designtype),
        "fabricCode": getCreateMeasurementCategory(document.querySelector(`[data-product-fitsmart-attributes-ele]`).dataset.fabricId)
      }];
      
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: JSON.stringify(bodyOBJ)
      };
      // console.log("requestOptions",requestOptions);
      fetch(`${baseUrlBsc}/order-module/getTat?customerPincode=${pincode}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("result",result);
        if(result.tatDetails[0].customerDeliveryDays != null){
          let deliveryDays = result.tatDetails[0].customerDeliveryDays;
          let deliveryTimestamp = Date.now() + (60*60*24*1000*deliveryDays);
          let deliveryDate = new Date(deliveryTimestamp);
          // console.log("deliveryDate",deliveryDate);
          let deliveryObjByProTypesOBJ = JSON.parse(localStorage.deliveryObjByProTypes ? localStorage.deliveryObjByProTypes : '{}');  
          let now1 = new Date();
          let nextDay = new Date(now1);
          nextDay.setDate(now.getDate() + 1);
          nextDay.setHours(0, 0, 0, 0);
          let nextDayTimestamp = nextDay.getTime();
          
          let obj = {
            "message": `Free delivery by ${deliveryDate.getDate()} ${monthsArr[deliveryDate.getMonth()]}`,
            "time": nextDayTimestamp
          }
          if(deliveryObjByProTypesOBJ[`${proType}`] == undefined) deliveryObjByProTypesOBJ[`${proType}`] = {};
          deliveryObjByProTypesOBJ[`${proType}`][`${pincode}`] = obj;
          // console.log("deliveryObjByProTypesOBJ",deliveryObjByProTypesOBJ);
          localStorage.deliveryObjByProTypes = JSON.stringify(deliveryObjByProTypesOBJ);
          // if(document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`)) document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`).innerHTML = `Free delivery by ${deliveryDate.getDate()} ${monthsArr[deliveryDate.getMonth()]}`;
          function getDaySuffix(day) {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
              case 1: return 'st';
              case 2: return 'nd';
              case 3: return 'rd';
              default: return 'th';
            }
          }

          const day = deliveryDate.getDate();
          const suffix = getDaySuffix(day);

          const fullMonthsArr = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
          if(document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`)) document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`).innerHTML = `Free shipping : <span class="custom-prod-delivery-span">${day}${suffix} ${fullMonthsArr[deliveryDate.getMonth()]}</span>`;
        }else{
          // show shiping by
          let deliveryDays = result.tatDetails[0].customerShipByDays;
          let deliveryTimestamp = Date.now() + (60*60*24*1000*deliveryDays);
          let deliveryDate = new Date(deliveryTimestamp);
          // console.log("deliveryDate",deliveryDate);
          let deliveryObjByProTypesOBJ = JSON.parse(localStorage.deliveryObjByProTypes ? localStorage.deliveryObjByProTypes : '{}');  
          let now1 = new Date();
          let nextDay = new Date(now1);
          nextDay.setDate(now.getDate() + 1);
          nextDay.setHours(0, 0, 0, 0);
          let nextDayTimestamp = nextDay.getTime();
          let obj = {
            "message": `Free shipping by ${deliveryDate.getDate()} ${monthsArr[deliveryDate.getMonth()]}`,
            "time": nextDayTimestamp
          }
          if(deliveryObjByProTypesOBJ[`${proType}`] == undefined) deliveryObjByProTypesOBJ[`${proType}`] = {};
          deliveryObjByProTypesOBJ[`${proType}`][`${pincode}`] = obj;
          // console.log("deliveryObjByProTypesOBJ",deliveryObjByProTypesOBJ);
          localStorage.deliveryObjByProTypes = JSON.stringify(deliveryObjByProTypesOBJ);
          // if(document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`)) document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`).innerHTML = `Free shipping by ${deliveryDate.getDate()} ${monthsArr[deliveryDate.getMonth()]}`;
          function getDaySuffix(day) {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
              case 1: return 'st';
              case 2: return 'nd';
              case 3: return 'rd';
              default: return 'th';
            }
          }

          const day = deliveryDate.getDate();
          const suffix = getDaySuffix(day);

          const fullMonthsArr = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
          if(document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`)) document.querySelector(`.cd-info-grid-item-info-dd [data-free-delivery-ele]`).innerHTML = `Free shipping : <span class="custom-prod-delivery-span">${day}${suffix} ${fullMonthsArr[deliveryDate.getMonth()]}</span>`;
        }
      })
      .catch((error) => console.error(error));
    }
  }
}

function manageCustomerPincodeStats(){
  // console.log("manageCustomerPincodeStats>>>>>",localStorage.customerPincode);
  if(localStorage.customerPincode != "" && localStorage.customerPincode != undefined){
    if(document.querySelector("[data-cd-pincode-form-input]")) document.querySelector("[data-cd-pincode-form-input]").value = localStorage.customerPincode;
    if(document.querySelector(".pro-check-delivery")) document.querySelector(".pro-check-delivery").classList.add("show-cd-details");
    if(document.querySelector(`[data-cd-store-details]`)) document.querySelector(`[data-cd-store-details]`).innerHTML = `${localStorage.customerNearestStore}`;
    if(document.querySelector(`.cd-info-grid-item-info-pincode a`)) document.querySelector(`.cd-info-grid-item-info-pincode a`).href = `/pages/stores?pinval=${localStorage.customerPincode}`;
    if(localStorage.customerNearestStore != undefined && localStorage.customerNearestStore.includes("No nearby")){
      if(document.querySelector(`.cd-info-grid-item-info-pincode a`)) document.querySelector(`.cd-info-grid-item-info-pincode a`).innerHTML = "VIEW ALL STORES";
      if(document.querySelector(".pro-check-delivery")) document.querySelector(".pro-check-delivery").classList.add("no-stores");
    }else{
      if(document.querySelector(`.cd-info-grid-item-info-pincode a`)) document.querySelector(`.cd-info-grid-item-info-pincode a`).innerHTML = "VIEW DETAILS";
    }
    if(document.querySelector(`.cd-info-grid-item-info-hv a:not(.badge-coming-soon)`)) document.querySelector(`.cd-info-grid-item-info-hv a:not(.badge-coming-soon)`).href = `/pages/travelling-stylist?editCustomisations=true&pincode=${localStorage.customerPincode}`;
    if(localStorage.customerPincodeAvailHV == "true"){
      if(document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`)) document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`).classList.add("hide");
      if(document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`)) document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`).classList.remove("hide");
    }else{
      if(document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`)) document.querySelector(`.cd-info-grid-item-info-hv a.view-slots-a`).classList.add("hide");
      if(document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`)) document.querySelector(`.cd-info-grid-item-info-hv a.badge-coming-soon`).classList.remove("hide");
    }
    getDeliveryCD(localStorage.customerPincode);

    if(document.querySelector("[data-ldg-pincode-form-input]")) document.querySelector("[data-ldg-pincode-form-input]").value = localStorage.customerPincode;
    if(document.querySelector("[data-ldg-pincode-form-submit]")){
      setTimeout(() => {
        document.querySelector("[data-ldg-pincode-form-submit]").removeAttribute("disabled");
        document.querySelector("[data-ldg-pincode-form-submit]").click();
      },5000);
    }
    
    document.addEventListener("DOMContentLoaded", (event) => {
      // console.log("DOM fully loaded and parsed");
      if(document.querySelector("#bh-sl-address")){
        setTimeout(() => {
          document.querySelector("#bh-sl-address").value = localStorage.customerPincode;
          popupPicode();
        },5000);
      }
    });
  }
}
manageCustomerPincodeStats();

var elem3 = document.querySelector('.ts-testimonial_slider') || null;
if(elem3){
  var flkty = new Flickity( elem3, {
  // options
  cellAlign: 'left',
  contain: true, 
  pageDots: true,
  prevNextButtons: false
  });
}

/*
=================================================
Check Delivery - ======> end
=================================================
*/

/*
=================================================
Creators page - ======> Start
=================================================
*/
if(document.body.classList.contains("temp_creators")){
  
if (document.body.clientWidth < 768) {
  var creator_slides = document.querySelectorAll('.creator_style_media_wrp');
  
  creator_slides.forEach(function(slide) {
    new Flickity(slide, {
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      contain: true
    });
  });
}


  document.addEventListener('DOMContentLoaded', function() {
    const ani_banner = document.querySelector(".main_creators_banner");
    ani_banner.classList.add("active");
  });
  
  document.addEventListener("scroll", (event) => {
    console.log("scroll");
    if(document.querySelector(".creator_style_heading:not(.active)")){
      // document.querySelectorAll(".creator_style_heading h2:not(.active)");
      var eleInView = isScrolledIntoViewC(document.querySelector(".creator_style_heading:not(.active)"));
      if(eleInView){
        document.querySelector(".creator_style_heading:not(.active)").classList.add("active");
      }
    }
  });
  
  function isScrolledIntoViewC(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  window.addEventListener("beforeunload", function(){
    window.scrollTo(0,0);
  });
}

var lenisOBJ = null;
if(document.body.classList.contains("temp_creators") || 
   document.body.classList.contains("temp_composition") || 
   document.body.classList.contains("temp_travelling-stylist") || 
   document.body.classList.contains("temp_wrinkle-free") || 
   document.body.classList.contains("temp_kin") || 
   document.body.classList.contains("temp_winter") || 
   document.body.classList.contains("weekend-at-the-kin") || 
   document.body.classList.contains("temp_mill")  || 
   document.body.classList.contains("temp_the-gentlemans-cut") ||
   document.body.classList.contains("temp_weaves") || 
   document.body.classList.contains("temp_the-den") || 
   document.body.classList.contains("temp_about") || 
   document.body.classList.contains("the-best-dressed-guest") || 
  document.body.classList.contains("temp_utility-rewired") || 
   document.body.classList.contains("temp_personalised-service") || 
   document.body.classList.contains("temp_luxurious-fabrics") || 
    document.body.classList.contains("temp_jim-sarbh") || 
   document.body.classList.contains("temp_expert-tailoring")){


 
// Let the browser restore scroll position naturally
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'auto';
}

window.addEventListener('load', () => {
  
  
  // Delay GSAP/Lenis init to avoid early animations during scroll restore
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
    
      gsap.registerPlugin(ScrollTrigger);
      lenisOBJ = new Lenis({
        lerp: 0.03,
        smooth: true
      });

      lenisOBJ.on('scroll', ScrollTrigger.update);
      console.log("lenisOBJ>>>>>>>>>>>>>>>>",lenisOBJ);
      gsap.ticker.add((time) => {
        lenisOBJ.raf(time * 2500);
      });


 

      
      // Your GSAP reveal animation
      gsap.utils.toArray('.reveal-scroll').forEach((e) => {
        let t = e.querySelector(".g_visual_wrap");
        if (!t) return;

        gsap.timeline({
          scrollTrigger: {
            trigger: e,
            start: "top 80%",
             // markers: true ,
            toggleActions: "play none none none"
            // toggleActions: "restart pause resume reverse"
          }
        })
        .from(e, {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
          duration: 1,
          ease: "power2.out"
        })
        .from(t, {
          scale: 1.5,
          duration: 1.2,
          ease: "power2.out"
        }, 0);
      });

      gsap.utils.toArray('.creator_parallax_img_container').forEach(container => {
        const img = container.querySelector('img');
        
        console.log(container.offsetHeight);
        console.log(img.offsetHeight);
            gsap.fromTo(img, {
          y: () => container.offsetHeight - img.offsetHeight,
        }, {      
          scrollTrigger: {
            trigger: container,
            scrub: 0.5,
            invalidateOnRefresh: true
          },
          y: 0,
          ease: "none"
        });
      });
      

    });
  });
});

  
//   gsap.registerPlugin(ScrollTrigger);
//   document.body.classList.add("is-loading");
//   const lenis = new Lenis({
//     lerp: 0.07
//   });

//   lenis.on('scroll', ScrollTrigger.update);

//   gsap.ticker.add((time)=>{
//     lenis.raf(time * 1000)
//   });

//   window.addEventListener('load', () => {
//   if (document.body.classList.contains("temp_about")) {
//     // Reset scroll immediately through Lenis
//     lenis.scrollTo(0, { immediate: true });
//   }

//   // Remove loader class after scroll is set
//   requestAnimationFrame(() => {
//     document.body.classList.remove("is-loading");
//   });
// });




// gsap.registerPlugin(ScrollTrigger);

// // Add loading class early (in HTML or JS)
// document.body.classList.add("is-loading");

// // Step 1: Initialize Lenis
// const lenis = new Lenis({
//   lerp: 0.07,
//   smooth: true
// });

// // Step 2: Connect Lenis with GSAP
// lenis.on('scroll', ScrollTrigger.update);
// gsap.ticker.add((time) => {
//   lenis.raf(time * 1000);
// });

// // Step 3: Ensure scroll to top *after* DOM & fonts are ready
// window.addEventListener('load', () => {
//   if (document.body.classList.contains("temp_about")) {
//     // Reset scroll immediately through Lenis
//     lenis.scrollTo(0, { immediate: true });
//   }

//   // Remove loader class after scroll is set
//   requestAnimationFrame(() => {
//     document.body.classList.remove("is-loading");
//   });
// });





  
  
  // gsap.utils.toArray('.creator_parallax_img_container').forEach(container => {
  //   const img = container.querySelector('img');
    
  //   console.log(container.offsetHeight);
  //   console.log(img.offsetHeight);
  //       gsap.fromTo(img, {
  //     y: () => container.offsetHeight - img.offsetHeight,
  //   }, {      
  //     scrollTrigger: {
  //       trigger: container,
  //       scrub: 0.5,
  //       invalidateOnRefresh: true
  //     },
  //     y: 0,
  //     ease: "none"
  //   });
  // });

}
/*
=================================================
Creators page - ======> end
=================================================
*/



/*
Personalised service - ======> start
=================================================
*/
if(document.body.classList.contains("temp_personalised-service")){
  if(document.body.clientWidth < 768){
    var creator_slide = document.querySelector('.personalised-style_second_video') || null;
    if(creator_slide){
      var flkty = new Flickity( creator_slide, {
      // options
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        contain: true
      });
    }
  }
}
/*
Personalised service - ======> end
=================================================
*/
/*
Expert Tailoring - ======> start
=================================================
*/
if(document.body.classList.contains("temp_expert-tailoring")){
  if(document.body.clientWidth < 768){
    var tailoring_slide = document.querySelector('.tailoring-seventh_img_text') || null;
    if(tailoring_slide){
      var flkty = new Flickity( tailoring_slide, {
      // options
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        contain: true
      });
    }
  }
}
/*
Expert Tailoring - ======> end
=================================================
*/
/*
Luxurious Fabrics - ======> start
=================================================
*/
// if(document.body.classList.contains("temp_luxurious-fabrics")){
//   if(document.body.clientWidth < 768){
//     var tailoring_slide = document.querySelector('.fabrics-style_second_wrp') || null;
//     if(tailoring_slide){
//       var flkty = new Flickity( tailoring_slide, {
//       // options
//         cellAlign: 'left',
//         pageDots: false,
//         prevNextButtons: false,
//         wrapAround: false,
//         contain: true
//       });
//     }
//   }
// }
/*
Luxurious Fabrics - ======> end
=================================================
*/






// Image drop animation - ======> start
// =================================================
 
// if (document.body.classList.contains("temp_weaves")) {
//   gsap.registerPlugin(ScrollTrigger);

//   window.addEventListener("load", () => {
//     // Handle all .reveal-scroll containers
//     const revealContainers = document.querySelectorAll(".reveal-scroll");

//     revealContainers.forEach((container) => {
//       const image = container.querySelector("img");

//       // Ensure the container and image exist
//       if (!container || !image) return;

//       const tl = gsap.timeline({
//         scrollTrigger: {
//           trigger: container,
//            start: "top 10%",    // animation starts when container top hits 85% of viewport height
//           end: "top 0",   // optional: defines end trigger (useful for scrub or visibility)
//           toggleActions: "restart none none reset",          
//           markers: true
//         }
//       });

//       tl.set(container, { autoAlpha: 1 });
//       tl.from(container, {
//         yPercent: -100,
//         duration: 1.5,
//         ease: Power2.out
//       });
//       tl.from(image, {
//         yPercent: 150,
//         scale: 1.3,
//         duration: 1.5,
//         ease: Power2.out
//       }, "-=1.5"); // Starts image anim at same time as container
//     });
//   });
// }




 

/*
Personalised service - ======> end
=================================================
*/


/*
=================================================
The Kin - ======> Start
=================================================
*/
if (document.body.classList.contains("temp_kin")) {
  document.addEventListener('DOMContentLoaded', function () {
    const ani_banner_kin = document.querySelector(".kin-style-1");
    ani_banner_kin.classList.add("active");
  });
}


// ---------split text animation ----
if (
  document.body.classList.contains("temp_kin") ||
  document.body.classList.contains("temp_about") ||
   document.body.classList.contains("temp_winter") || 
  document.body.classList.contains("the-best-dressed-guest") ||
  document.body.classList.contains("temp_the-gentlemans-cut") ||
  document.body.classList.contains("temp_weaves") ||
  document.body.classList.contains("temp_the-den") ||
  document.body.classList.contains("temp_personalised-service") ||
  document.body.classList.contains("temp_utility-rewired") ||
  document.body.classList.contains("temp_jim-sarbh") ||
  document.body.classList.contains("temp_luxurious-fabrics") ||
  document.body.classList.contains("temp_expert-tailoring")
) {
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(SplitText, ScrollTrigger);

    document.fonts.ready.then(() => {
      document.querySelectorAll(".kin_page_heading").forEach((el) => {
        // Apply SplitText
        const split = new SplitText(el, {
          type: "lines",
          linesClass: "split-line"
        });

        // Wrap each split line
        split.lines.forEach(line => {
          const wrapper = document.createElement("div");
          wrapper.classList.add("split-parent");
          wrapper.style.overflow = "hidden";
          line.parentNode.insertBefore(wrapper, line);
          wrapper.appendChild(line);
        });

        // Scroll animation
        gsap.from(split.lines, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            end: "+=100%",
            // toggleActions: "restart pause resume reverse",
            toggleActions: "play none none none",
            markers: false // hidden
          },
          autoAlpha: 0,
          yPercent: 100,
          ease: "none",
          duration: 0.6
        });
      });
    });
  });
}





/*
=================================================
The Kin - ======> end
=================================================
*/











// =======================about top animation==========================


 if(document.body.classList.contains("temp_about")){
  gsap.registerPlugin(SplitText, ScrollTrigger);
    $(document).ready(function () {     
    // function createScrollTrigger() {
    //   ScrollTrigger.killAll(); // Clear any existing triggers
    
    //   let startValue;
    
    //   if (window.matchMedia("(max-width: 480px)").matches) {
    //     startValue = "top 51px"; // Below 991px
    //   } else if (window.matchMedia("(max-width: 768px)").matches) {
    //     startValue = "top 51px"; // Below 991px
    //   } else if (window.matchMedia("(max-width: 1007px)").matches) {
    //     startValue = "top 58px"; // Below 1200px
    //   } else {
    //     startValue = "top 67px"; // Above 1200px (default fallback)
    //   }
    
    //   ScrollTrigger.create({
    //     trigger: ".about-top-block",
    //     start: startValue,
    //     end: "+=15%",
    //     pin: true,
    //     pinSpacing: true,
    //     scrub: true,
    //     markers: true
    //   });
    // }
    
 
    // createScrollTrigger();
    // window.addEventListener("resize", () => {
    //   ScrollTrigger.refresh();
    //   createScrollTrigger();
    // });
    
    
    
      const wrapTwo = document.querySelector(".aboutus-banner_content.wrap.two");    
      if (wrapTwo) {
        const headings = wrapTwo.querySelectorAll("h3.quote-2");
        const paragraphs = wrapTwo.querySelectorAll("div.quote");
      
        const animateFromBelow = (elements) => {
          elements.forEach(el => {
            el.split = new SplitText(el, {
              type: "lines",
              linesClass: "split-line"
            });
      
            $(el).find(".split-line").wrap('<div class="split-parent" style="overflow: hidden;"></div>');
      
            gsap.from(el.split.lines, {
              scrollTrigger: {
               trigger: ".aboutus-style-banner_wrp",
                // start: "top 6%",
                start: "top 2%",
                toggleActions: "restart pause resume reverse",
                end: "+=100%",
                markers: false
              },
              autoAlpha: 0,
              yPercent: 100,
              ease: "none",
              duration: 0.6
            });
          });
        };
      
        animateFromBelow(headings);
        animateFromBelow(paragraphs);
      }    
      
      const wrapOne = document.querySelector(".aboutus-banner_content.wrap.one");
      if (wrapOne) {
        const headings = wrapOne.querySelectorAll("h3.quote-2");
        const paragraphs = wrapOne.querySelectorAll("div.quote");
      
        const animateLines = (elements) => {
          elements.forEach(el => {
            el.split = new SplitText(el, {
              type: "lines",
              linesClass: "split-line"
            });
      
            $(el).find(".split-line").wrap('<div class="split-parent" style="overflow: hidden;"></div>');
      
            gsap.to(el.split.lines, {
              scrollTrigger: {
                trigger: ".aboutus-style-banner_wrp",
                toggleActions: "restart pause resume reverse",
                // start: "top 6%",
                start: "top 2%",
                end: "+=100%",
                markers: false
              },
              autoAlpha: 0,
              yPercent: -100,  // 🔁 changed from 100 to -100 to match h3 behavior
              ease: "none",
              duration: 0.6
            });
          });
        };
      
        animateLines(headings);   // h3 animation
        animateLines(paragraphs); // p animation now matches h3
      }
    });
 }

if(document.body.classList.contains("temp_the-gentlemans-cut")){
  if(document.body.clientWidth < 992){
    var tailoring_slide = document.querySelector('.gent-four-images') || null;
    if(tailoring_slide){
      var flkty = new Flickity( tailoring_slide, {
      // options
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        contain: true
      });
    }
  }
}


/*
=================================================
Daily drops - ======> start
=================================================
*/

if (document.body.classList.contains("temp_daily-drops") && window.innerWidth < 767){
    var tailoring_slideArr = document.querySelectorAll('.grid-style-4 .ProductList--grid');
    tailoring_slideArr.forEach(slider => {
      var flkty = new Flickity( slider, {
      // options
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        contain: true
      });
    });

   // var tailoring_slide5Arr = document.querySelectorAll('.grid-style-5 .second-block');
   //  tailoring_slide5Arr.forEach(slider => {
   //    var flkty = new Flickity( slider, {
   //    // options
   //      cellAlign: 'left',
   //      pageDots: false,
   //      prevNextButtons: false,
   //      adaptiveHeight: true,
   //      wrapAround: false,
   //      contain: true
   //    });
   //  });

  const secondBlockSliderArr = document.querySelectorAll('.grid-style-5 .second-block-slider');  
  secondBlockSliderArr.forEach(slider => {
    // Wait for all images inside the slider to load
    imagesLoaded(slider, () => {
      new Flickity(slider, {
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      wrapAround: false,
      contain: true
      });
    });
  });
}

if (document.body.classList.contains("temp_jim-sarbh") && window.innerWidth < 767){
   var jim_sarbh_threeimg = document.querySelectorAll('.three-img-block .wrapp');
    jim_sarbh_threeimg.forEach(slider => {
      var flkty = new Flickity( slider, {
      // options
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        contain: true
      });
    });
}

 var tab_slider = document.querySelectorAll('.tab-rail-slider');
    tab_slider.forEach(slider => {
      var flkty = new Flickity( slider, {
      // options
        cellAlign: 'center',
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        contain: true,
        watchCSS: true,
        dragThreshold: 8,
        groupCells: true
      });
    });
 
 
// document.addEventListener("DOMContentLoaded", function () {
//   const titles = Array.from(document.querySelectorAll(".tab-title"));
//   const panels = Array.from(document.querySelectorAll(".tab-panels-inner"));

//   if (!titles.length || !panels.length) return; // nothing to do

//   // helper: activate by element references
//  function activateById(id, clickedTitle) {
//   // remove active from all
//   titles.forEach(t => t.classList.remove("is-active"));
//   panels.forEach(p => p.classList.remove("is-active"));

//   // add to the chosen ones
//   if (clickedTitle) clickedTitle.classList.add("is-active");
//   const target = document.getElementById(id);
//   if (target) {
//     target.classList.add("is-active");

//     // 🔑 find Flickity instance(s) inside this panel and force resize
//     const sliders = target.querySelectorAll('.tab-rail-slider');
//     sliders.forEach(slider => {
//       if (slider.flickityInstance) {
//         slider.flickityInstance.resize();
//           slider.flickityInstance.reloadCells();

//       }
//     });
//   }
// }

//   // initial: show first
//   titles[0].classList.add("is-active");
//   panels[0].classList.add("is-active");

//   // click handling
//   titles.forEach(title => {
//     title.addEventListener("click", () => {
//       const id = title.getAttribute("data-tab"); // must match panel's id
//       if (!id) return;
//       activateById(id, title);
//     });
//   });
// });



if (document.body.classList.contains("temp_daily-drops") || document.body.classList.contains("temp_in-stock") || document.body.classList.contains("template-index") || document.body.classList.contains("temp_homepage2")){
  function parseCustomDate(dateStr) {
    const parts = dateStr.trim().split(" ");
    if (parts.length !== 2) return null;    
    const dateParts = parts[0].split("-");
    const timeParts = parts[1].split(":");    
    if (dateParts.length !== 3 || timeParts.length < 2) return null;    
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const year = parseInt(dateParts[2], 10);
    const hour = parseInt(timeParts[0], 10);
    const minute = parseInt(timeParts[1], 10);
    const second = timeParts[2] ? parseInt(timeParts[2], 10) : 0;    
    return new Date(year, month, day, hour, minute, second);
  }
  
  function startCountdown() {
    const container = document.getElementById('countdown-timer');
    if(container){
      const endTimeStr = container.getAttribute('data-end-time');
      const timerSpan = container.querySelector('.timer-display');
      
      const endTime = parseCustomDate(endTimeStr);
      if (!endTime || isNaN(endTime.getTime())) {
        timerSpan.innerHTML = "Invalid date format";
        return;
      }    
      function updateTimer() {
        // console.log("updateTimer>>>>>");
        const now = new Date().getTime();
        const distance = endTime.getTime() - now;    
        if (distance <= 0) {
        timerSpan.innerHTML = "Expired";
        clearInterval(timerInterval);
        return;
        }    
        let hours = Math.floor(distance / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // console.log("hours",hours,"minutes",minutes,"seconds",seconds);
        if(hours < 10){
          hours = `0${hours}`;
        }
        if(minutes < 10){
          minutes = `0${minutes}`;
        }
        if(seconds < 10){
          seconds = `0${seconds}`;
        }
        timerSpan.innerHTML =
        `<span class="cd-hours tmm"><span class="tm"><span>${hours}</span><span class="cd-label">HRS</span></span><span class="divider"><svg width="8" height="22" viewBox="0 0 8 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="4" r="4" fill="white"/><circle cx="4" cy="18" r="4" fill="white"/></svg></span></span> ` +
        `<span class="cd-mins tmm"><span class="tm"><span>${minutes}</span><span class="cd-label">MINS</span></span> <span class="divider"><svg width="8" height="22" viewBox="0 0 8 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="4" r="4" fill="white"/><circle cx="4" cy="18" r="4" fill="white"/></svg></span></span> ` +
        `<span class="cd-secs tmm"><span class="tm"><span>${seconds}</span><span class="cd-label">SECS</span></span> </span>`;
      }    
      updateTimer();
      const timerInterval = setInterval(updateTimer, 1000);
    }
  }
  startCountdown();
}



const instockTab = document.querySelector(".ins-tab");
if(instockTab){
const upcomingTab = document.querySelector(".ups-tab");
const instockItems = document.querySelector(".instock-items");
const upcomingItems = document.querySelector(".upcoming-items");

const instockLink = document.querySelector(".ins-link");
const upcomingLink = document.querySelector(".ups-link");

let flickityInitialized = false;

instockTab.addEventListener("click", function () {
  // Show instock content + link
  instockItems.style.display = "block";
  instockLink.style.display = "block";

  // Hide upcoming content + link
  upcomingItems.style.display = "none";
  upcomingLink.style.display = "none";

  // Toggle active classes
  instockTab.classList.add("active");
  upcomingTab.classList.remove("active");
});

upcomingTab.addEventListener("click", function () {
  // Show upcoming content + link
  instockItems.style.display = "none";
  instockLink.style.display = "none";

  upcomingItems.style.display = "block";
  upcomingLink.style.display = "block";

  // Toggle active classes
  upcomingTab.classList.add("active");
  instockTab.classList.remove("active");

  // Initialize Flickity only once
  if (!flickityInitialized) {
    const carousel = document.querySelector(".upcoming-items .ProductList");
    if (carousel) {
      new Flickity(carousel, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: false
      });
      flickityInitialized = true;
    } else {
      console.warn("Flickity: .carousel not found inside .upcoming-items");
    }
  }
});
}

/*
=================================================
Daily drops - ======> end
=================================================
*/


let tabsRailSection = document.querySelectorAll(`.featured-collections.tabs .tab-title`);
tabsRailSection.forEach(ele => {
  ele.addEventListener("click",function(e){
    e.preventDefault();
    document.querySelector(`.featured-collections.tabs .tab-title.active`)?.classList.remove("active");
    this.classList.add("active");
    this.closest(".shopify-section").querySelector(".SectionHeader__Heading .pro-count").innerHTML = this.dataset.count;
    this.closest(".tab-title-wrapp").querySelector("a.Link").href = this.dataset.url;
    document.querySelector(".tab-panels-inner.active")?.classList.remove("active");
    document.querySelector(`#${this.dataset.tab}.tab-panels-inner`)?.classList.add("active");
    window.dispatchEvent(new Event('resize'));
  });
});

var speed = $('.announce_slide').attr('data-speed');
if($('.announce_slide').length > 0){
  let flktyAnnounce = new Flickity('.announce_slide',{
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    initialIndex: 1,
    groupCells: 1,
    cellAlign: "center",
    contain: true,
    fade: true,
    autoPlay: true // advance cells every 3 seconds
  });
}





  